window.YaficoMediaMasters = {
  "lighting-campaign-neris-orange-night-v1.webp": {
    "src": "lighting-campaign-neris-orange-night-v1-hq2x-v1.webp",
    "displaySrc": "lighting-campaign-neris-orange-night-v1-sharp-v1.webp",
    "width": 3172,
    "height": 1984,
    "originalWidth": 1586,
    "originalHeight": 992,
    "sources": [
      {
        "src": "lighting-campaign-neris-orange-night-v1-sharp-900-v1.webp",
        "width": 900
      },
      {
        "src": "lighting-campaign-neris-orange-night-v1-sharp-1400-v1.webp",
        "width": 1400
      },
      {
        "src": "lighting-campaign-neris-orange-night-v1-sharp-v1.webp",
        "width": 1586
      },
      {
        "src": "lighting-campaign-neris-orange-night-v1-sharp-2000-v1.webp",
        "width": 2000
      },
      {
        "src": "lighting-campaign-neris-orange-night-v1-sharp-2400-v1.webp",
        "width": 2400
      },
      {
        "src": "lighting-campaign-neris-orange-night-v1-hq2x-v1.webp",
        "width": 3172
      }
    ]
  },
  "lighting-07-natural-life-01-v1.webp": {
    "src": "lighting-07-natural-life-01-v1-hq2x-v1.webp",
    "displaySrc": "lighting-07-natural-life-01-v1-sharp-v1.webp",
    "width": 2244,
    "height": 2804,
    "originalWidth": 1122,
    "originalHeight": 1402,
    "sources": [
      {
        "src": "lighting-07-natural-life-01-v1-sharp-640-v1.webp",
        "width": 640
      },
      {
        "src": "lighting-07-natural-life-01-v1-sharp-v1.webp",
        "width": 1122
      },
      {
        "src": "lighting-07-natural-life-01-v1-sharp-1600-v1.webp",
        "width": 1600
      },
      {
        "src": "lighting-07-natural-life-01-v1-hq2x-v1.webp",
        "width": 2244
      }
    ]
  },
  "lighting-campaign-neris-orange-day-v1.webp": {
    "src": "lighting-campaign-neris-orange-day-v1-hq2x-v1.webp",
    "displaySrc": "lighting-campaign-neris-orange-day-v1-sharp-v1.webp",
    "width": 3172,
    "height": 1984,
    "originalWidth": 1586,
    "originalHeight": 992,
    "sources": [
      {
        "src": "lighting-campaign-neris-orange-day-v1-sharp-900-v1.webp",
        "width": 900
      },
      {
        "src": "lighting-campaign-neris-orange-day-v1-sharp-1400-v1.webp",
        "width": 1400
      },
      {
        "src": "lighting-campaign-neris-orange-day-v1-sharp-v1.webp",
        "width": 1586
      },
      {
        "src": "lighting-campaign-neris-orange-day-v1-sharp-2000-v1.webp",
        "width": 2000
      },
      {
        "src": "lighting-campaign-neris-orange-day-v1-sharp-2400-v1.webp",
        "width": 2400
      },
      {
        "src": "lighting-campaign-neris-orange-day-v1-hq2x-v1.webp",
        "width": 3172
      }
    ]
  },
  "lighting-07-natural-life-03-v1.webp": {
    "src": "lighting-07-natural-life-03-v1-hq2x-v1.webp",
    "displaySrc": "lighting-07-natural-life-03-v1-sharp-v1.webp",
    "width": 2244,
    "height": 2804,
    "originalWidth": 1122,
    "originalHeight": 1402,
    "sources": [
      {
        "src": "lighting-07-natural-life-03-v1-sharp-640-v1.webp",
        "width": 640
      },
      {
        "src": "lighting-07-natural-life-03-v1-sharp-v1.webp",
        "width": 1122
      },
      {
        "src": "lighting-07-natural-life-03-v1-sharp-1600-v1.webp",
        "width": 1600
      },
      {
        "src": "lighting-07-natural-life-03-v1-hq2x-v1.webp",
        "width": 2244
      }
    ]
  },
  "lighting-07-natural-life-04-v1.webp": {
    "src": "lighting-07-natural-life-04-v1-hq2x-v1.webp",
    "displaySrc": "lighting-07-natural-life-04-v1-sharp-v1.webp",
    "width": 2244,
    "height": 2804,
    "originalWidth": 1122,
    "originalHeight": 1402,
    "sources": [
      {
        "src": "lighting-07-natural-life-04-v1-sharp-640-v1.webp",
        "width": 640
      },
      {
        "src": "lighting-07-natural-life-04-v1-sharp-v1.webp",
        "width": 1122
      },
      {
        "src": "lighting-07-natural-life-04-v1-sharp-1600-v1.webp",
        "width": 1600
      },
      {
        "src": "lighting-07-natural-life-04-v1-hq2x-v1.webp",
        "width": 2244
      }
    ]
  },
  "lighting-07-natural-life-05-v1.webp": {
    "src": "lighting-07-natural-life-05-v1-hq2x-v1.webp",
    "displaySrc": "lighting-07-natural-life-05-v1-sharp-v1.webp",
    "width": 2244,
    "height": 2804,
    "originalWidth": 1122,
    "originalHeight": 1402,
    "sources": [
      {
        "src": "lighting-07-natural-life-05-v1-sharp-640-v1.webp",
        "width": 640
      },
      {
        "src": "lighting-07-natural-life-05-v1-sharp-v1.webp",
        "width": 1122
      },
      {
        "src": "lighting-07-natural-life-05-v1-sharp-1600-v1.webp",
        "width": 1600
      },
      {
        "src": "lighting-07-natural-life-05-v1-hq2x-v1.webp",
        "width": 2244
      }
    ]
  },
  "lighting-07-natural-studio-lit-v1.webp": {
    "src": "lighting-07-natural-studio-lit-v1-hq2x-v1.webp",
    "displaySrc": "lighting-07-natural-studio-lit-v1-sharp-v1.webp",
    "width": 2508,
    "height": 2508,
    "originalWidth": 1254,
    "originalHeight": 1254,
    "sources": [
      {
        "src": "lighting-07-natural-studio-lit-v1-sharp-640-v1.webp",
        "width": 640
      },
      {
        "src": "lighting-07-natural-studio-lit-v1-sharp-v1.webp",
        "width": 1254
      },
      {
        "src": "lighting-07-natural-studio-lit-v1-sharp-1600-v1.webp",
        "width": 1600
      },
      {
        "src": "lighting-07-natural-studio-lit-v1-hq2x-v1.webp",
        "width": 2508
      }
    ]
  },
  "lighting-01-studio-v2.webp": {
    "src": "lighting-01-studio-v2-hq2x-v1.webp",
    "displaySrc": "lighting-01-studio-v2-sharp-v1.webp",
    "width": 2508,
    "height": 2508,
    "originalWidth": 1254,
    "originalHeight": 1254,
    "sources": [
      {
        "src": "lighting-01-studio-v2-sharp-640-v1.webp",
        "width": 640
      },
      {
        "src": "https://cdn.shopify.com/s/files/1/0922/9919/8790/files/yafico-lighting-responsive-r5-01-studio_800x.jpg?v=1793351077",
        "width": 800
      },
      {
        "src": "lighting-01-studio-v2-sharp-v1.webp",
        "width": 1254
      },
      {
        "src": "lighting-01-studio-v2-sharp-1600-v1.webp",
        "width": 1600
      },
      {
        "src": "lighting-01-studio-v2-hq2x-v1.webp",
        "width": 2508
      }
    ]
  },
  "lighting-09-life-01-v4.webp": {
    "src": "lighting-09-life-01-v4-hq2x-v1.webp",
    "displaySrc": "lighting-09-life-01-v4-sharp-v1.webp",
    "width": 2244,
    "height": 2804,
    "originalWidth": 1122,
    "originalHeight": 1402,
    "sources": [
      {
        "src": "lighting-09-life-01-v4-sharp-640-v1.webp",
        "width": 640
      },
      {
        "src": "https://cdn.shopify.com/s/files/1/0922/9919/8790/files/yafico-lighting-responsive-r5-09-life_800x.jpg?v=1793316639",
        "width": 800
      },
      {
        "src": "lighting-09-life-01-v4-sharp-v1.webp",
        "width": 1122
      },
      {
        "src": "lighting-09-life-01-v4-sharp-1600-v1.webp",
        "width": 1600
      },
      {
        "src": "lighting-09-life-01-v4-hq2x-v1.webp",
        "width": 2244
      }
    ]
  },
  "lighting-10-studio-v2.webp": {
    "src": "lighting-10-studio-v2-hq2x-v1.webp",
    "displaySrc": "lighting-10-studio-v2-sharp-v1.webp",
    "width": 2508,
    "height": 2508,
    "originalWidth": 1254,
    "originalHeight": 1254,
    "sources": [
      {
        "src": "lighting-10-studio-v2-sharp-640-v1.webp",
        "width": 640
      },
      {
        "src": "lighting-10-studio-v2-sharp-v1.webp",
        "width": 1254
      },
      {
        "src": "lighting-10-studio-v2-sharp-1600-v1.webp",
        "width": 1600
      },
      {
        "src": "lighting-10-studio-v2-hq2x-v1.webp",
        "width": 2508
      }
    ]
  },
  "lighting-07-natural-life-02-v1.webp": {
    "src": "lighting-07-natural-life-02-v1-hq2x-v1.webp",
    "displaySrc": "lighting-07-natural-life-02-v1-sharp-v1.webp",
    "width": 2244,
    "height": 2804,
    "originalWidth": 1122,
    "originalHeight": 1402,
    "sources": [
      {
        "src": "lighting-07-natural-life-02-v1-sharp-640-v1.webp",
        "width": 640
      },
      {
        "src": "lighting-07-natural-life-02-v1-sharp-v1.webp",
        "width": 1122
      },
      {
        "src": "lighting-07-natural-life-02-v1-sharp-1600-v1.webp",
        "width": 1600
      },
      {
        "src": "lighting-07-natural-life-02-v1-hq2x-v1.webp",
        "width": 2244
      }
    ]
  },
  "lighting-01-life-03-v3.webp": {
    "src": "lighting-01-life-03-v3-hq2x-v1.webp",
    "displaySrc": "lighting-01-life-03-v3-sharp-v1.webp",
    "width": 2244,
    "height": 2804,
    "originalWidth": 1122,
    "originalHeight": 1402,
    "sources": [
      {
        "src": "lighting-01-life-03-v3-sharp-640-v1.webp",
        "width": 640
      },
      {
        "src": "https://cdn.shopify.com/s/files/1/0922/9919/8790/files/yafico-lighting-responsive-r5-01-life_800x.jpg?v=1793351077",
        "width": 800
      },
      {
        "src": "lighting-01-life-03-v3-sharp-v1.webp",
        "width": 1122
      },
      {
        "src": "lighting-01-life-03-v3-sharp-1600-v1.webp",
        "width": 1600
      },
      {
        "src": "lighting-01-life-03-v3-hq2x-v1.webp",
        "width": 2244
      }
    ]
  },
  "lighting-09-studio-v2.webp": {
    "src": "lighting-09-studio-v2-hq2x-v1.webp",
    "displaySrc": "lighting-09-studio-v2-sharp-v1.webp",
    "width": 2508,
    "height": 2508,
    "originalWidth": 1254,
    "originalHeight": 1254,
    "sources": [
      {
        "src": "lighting-09-studio-v2-sharp-640-v1.webp",
        "width": 640
      },
      {
        "src": "https://cdn.shopify.com/s/files/1/0922/9919/8790/files/yafico-lighting-responsive-r5-09-studio_800x.jpg?v=1793351076",
        "width": 800
      },
      {
        "src": "lighting-09-studio-v2-sharp-v1.webp",
        "width": 1254
      },
      {
        "src": "lighting-09-studio-v2-sharp-1600-v1.webp",
        "width": 1600
      },
      {
        "src": "lighting-09-studio-v2-hq2x-v1.webp",
        "width": 2508
      }
    ]
  },
  "lighting-10-life-01-v4.webp": {
    "src": "lighting-10-life-01-v4-hq2x-v1.webp",
    "displaySrc": "lighting-10-life-01-v4-sharp-v1.webp",
    "width": 2244,
    "height": 2804,
    "originalWidth": 1122,
    "originalHeight": 1402,
    "sources": [
      {
        "src": "lighting-10-life-01-v4-sharp-640-v1.webp",
        "width": 640
      },
      {
        "src": "lighting-10-life-01-v4-sharp-v1.webp",
        "width": 1122
      },
      {
        "src": "lighting-10-life-01-v4-sharp-1600-v1.webp",
        "width": 1600
      },
      {
        "src": "lighting-10-life-01-v4-hq2x-v1.webp",
        "width": 2244
      }
    ]
  },
  "lighting-10-life-02-v4.webp": {
    "src": "lighting-10-life-02-v4-hq2x-v1.webp",
    "displaySrc": "lighting-10-life-02-v4-sharp-v1.webp",
    "width": 2244,
    "height": 2804,
    "originalWidth": 1122,
    "originalHeight": 1402,
    "sources": [
      {
        "src": "lighting-10-life-02-v4-sharp-640-v1.webp",
        "width": 640
      },
      {
        "src": "lighting-10-life-02-v4-sharp-v1.webp",
        "width": 1122
      },
      {
        "src": "lighting-10-life-02-v4-sharp-1600-v1.webp",
        "width": 1600
      },
      {
        "src": "lighting-10-life-02-v4-hq2x-v1.webp",
        "width": 2244
      }
    ]
  },
  "lighting-15-life-02-v4.webp": {
    "src": "lighting-15-life-02-v4-hq2x-v1.webp",
    "displaySrc": "lighting-15-life-02-v4-sharp-v1.webp",
    "width": 2244,
    "height": 2804,
    "originalWidth": 1122,
    "originalHeight": 1402,
    "sources": [
      {
        "src": "lighting-15-life-02-v4-sharp-640-v1.webp",
        "width": 640
      },
      {
        "src": "lighting-15-life-02-v4-sharp-v1.webp",
        "width": 1122
      },
      {
        "src": "lighting-15-life-02-v4-sharp-1600-v1.webp",
        "width": 1600
      },
      {
        "src": "lighting-15-life-02-v4-hq2x-v1.webp",
        "width": 2244
      }
    ]
  },
  "lighting-campaign-duo-v6.webp": {
    "src": "lighting-campaign-duo-v6-hq2x-v1.webp",
    "displaySrc": "lighting-campaign-duo-v6-sharp-v1.webp",
    "width": 3000,
    "height": 2000,
    "originalWidth": 1500,
    "originalHeight": 1000,
    "sources": [
      {
        "src": "lighting-campaign-duo-v6-sharp-640-v1.webp",
        "width": 640
      },
      {
        "src": "lighting-campaign-duo-v6-sharp-v1.webp",
        "width": 1500
      },
      {
        "src": "lighting-campaign-duo-v6-sharp-1600-v1.webp",
        "width": 1600
      },
      {
        "src": "lighting-campaign-duo-v6-hq2x-v1.webp",
        "width": 3000
      }
    ]
  },
  "lighting-campaign-orva-v2.webp": {
    "src": "lighting-campaign-orva-v2-hq2x-v1.webp",
    "displaySrc": "lighting-campaign-orva-v2-sharp-v1.webp",
    "width": 2244,
    "height": 2804,
    "originalWidth": 1122,
    "originalHeight": 1402,
    "sources": [
      {
        "src": "lighting-campaign-orva-v2-sharp-640-v1.webp",
        "width": 640
      },
      {
        "src": "lighting-campaign-orva-v2-sharp-v1.webp",
        "width": 1122
      },
      {
        "src": "lighting-campaign-orva-v2-sharp-1600-v1.webp",
        "width": 1600
      },
      {
        "src": "lighting-campaign-orva-v2-hq2x-v1.webp",
        "width": 2244
      }
    ]
  },
  "lighting-evening-aurel-v10.webp": {
    "src": "lighting-evening-aurel-v10-hq2x-v1.webp",
    "displaySrc": "lighting-evening-aurel-v10-sharp-v1.webp",
    "width": 2200,
    "height": 2750,
    "originalWidth": 1100,
    "originalHeight": 1375,
    "sources": [
      {
        "src": "lighting-evening-aurel-v10-sharp-640-v1.webp",
        "width": 640
      },
      {
        "src": "lighting-evening-aurel-v10-sharp-v1.webp",
        "width": 1100
      },
      {
        "src": "lighting-evening-aurel-v10-sharp-1600-v1.webp",
        "width": 1600
      },
      {
        "src": "lighting-evening-aurel-v10-hq2x-v1.webp",
        "width": 2200
      }
    ]
  },
  "lighting-kyra-atmosphere-v7.webp": {
    "src": "lighting-kyra-atmosphere-v7-hq2x-v1.webp",
    "displaySrc": "lighting-kyra-atmosphere-v7-sharp-v1.webp",
    "width": 2200,
    "height": 2750,
    "originalWidth": 1100,
    "originalHeight": 1375,
    "sources": [
      {
        "src": "lighting-kyra-atmosphere-v7-sharp-640-v1.webp",
        "width": 640
      },
      {
        "src": "lighting-kyra-atmosphere-v7-sharp-v1.webp",
        "width": 1100
      },
      {
        "src": "lighting-kyra-atmosphere-v7-sharp-1600-v1.webp",
        "width": 1600
      },
      {
        "src": "lighting-kyra-atmosphere-v7-hq2x-v1.webp",
        "width": 2200
      }
    ]
  },
  "lighting-02-studio-v2.webp": {
    "src": "lighting-02-studio-v2-hq2x-v1.webp",
    "displaySrc": "lighting-02-studio-v2-sharp-v1.webp",
    "width": 2508,
    "height": 2508,
    "originalWidth": 1254,
    "originalHeight": 1254,
    "sources": [
      {
        "src": "lighting-02-studio-v2-sharp-640-v1.webp",
        "width": 640
      },
      {
        "src": "lighting-02-studio-v2-sharp-v1.webp",
        "width": 1254
      },
      {
        "src": "lighting-02-studio-v2-sharp-1600-v1.webp",
        "width": 1600
      },
      {
        "src": "lighting-02-studio-v2-hq2x-v1.webp",
        "width": 2508
      }
    ]
  },
  "lighting-03-studio-v2.webp": {
    "src": "lighting-03-studio-v2-hq2x-v1.webp",
    "displaySrc": "lighting-03-studio-v2-sharp-v1.webp",
    "width": 2508,
    "height": 2508,
    "originalWidth": 1254,
    "originalHeight": 1254,
    "sources": [
      {
        "src": "lighting-03-studio-v2-sharp-640-v1.webp",
        "width": 640
      },
      {
        "src": "lighting-03-studio-v2-sharp-v1.webp",
        "width": 1254
      },
      {
        "src": "lighting-03-studio-v2-sharp-1600-v1.webp",
        "width": 1600
      },
      {
        "src": "lighting-03-studio-v2-hq2x-v1.webp",
        "width": 2508
      }
    ]
  },
  "lighting-04-studio-v2.webp": {
    "src": "lighting-04-studio-v2-hq2x-v1.webp",
    "displaySrc": "lighting-04-studio-v2-sharp-v1.webp",
    "width": 2508,
    "height": 2508,
    "originalWidth": 1254,
    "originalHeight": 1254,
    "sources": [
      {
        "src": "lighting-04-studio-v2-sharp-640-v1.webp",
        "width": 640
      },
      {
        "src": "lighting-04-studio-v2-sharp-v1.webp",
        "width": 1254
      },
      {
        "src": "lighting-04-studio-v2-sharp-1600-v1.webp",
        "width": 1600
      },
      {
        "src": "lighting-04-studio-v2-hq2x-v1.webp",
        "width": 2508
      }
    ]
  },
  "lighting-05-studio-v2.webp": {
    "src": "lighting-05-studio-v2-hq2x-v1.webp",
    "displaySrc": "lighting-05-studio-v2-sharp-v1.webp",
    "width": 2508,
    "height": 2508,
    "originalWidth": 1254,
    "originalHeight": 1254,
    "sources": [
      {
        "src": "lighting-05-studio-v2-sharp-640-v1.webp",
        "width": 640
      },
      {
        "src": "lighting-05-studio-v2-sharp-v1.webp",
        "width": 1254
      },
      {
        "src": "lighting-05-studio-v2-sharp-1600-v1.webp",
        "width": 1600
      },
      {
        "src": "lighting-05-studio-v2-hq2x-v1.webp",
        "width": 2508
      }
    ]
  },
  "lighting-06-studio-v2.webp": {
    "src": "lighting-06-studio-v2-hq2x-v1.webp",
    "displaySrc": "lighting-06-studio-v2-sharp-v1.webp",
    "width": 2508,
    "height": 2508,
    "originalWidth": 1254,
    "originalHeight": 1254,
    "sources": [
      {
        "src": "lighting-06-studio-v2-sharp-640-v1.webp",
        "width": 640
      },
      {
        "src": "lighting-06-studio-v2-sharp-v1.webp",
        "width": 1254
      },
      {
        "src": "lighting-06-studio-v2-sharp-1600-v1.webp",
        "width": 1600
      },
      {
        "src": "lighting-06-studio-v2-hq2x-v1.webp",
        "width": 2508
      }
    ]
  },
  "lighting-07-studio-v2.webp": {
    "src": "lighting-07-studio-v2-hq2x-v1.webp",
    "displaySrc": "lighting-07-studio-v2-sharp-v1.webp",
    "width": 2508,
    "height": 2508,
    "originalWidth": 1254,
    "originalHeight": 1254,
    "sources": [
      {
        "src": "lighting-07-studio-v2-sharp-640-v1.webp",
        "width": 640
      },
      {
        "src": "lighting-07-studio-v2-sharp-v1.webp",
        "width": 1254
      },
      {
        "src": "lighting-07-studio-v2-sharp-1600-v1.webp",
        "width": 1600
      },
      {
        "src": "lighting-07-studio-v2-hq2x-v1.webp",
        "width": 2508
      }
    ]
  },
  "lighting-08-studio-v2.webp": {
    "src": "lighting-08-studio-v2-hq2x-v1.webp",
    "displaySrc": "lighting-08-studio-v2-sharp-v1.webp",
    "width": 2508,
    "height": 2508,
    "originalWidth": 1254,
    "originalHeight": 1254,
    "sources": [
      {
        "src": "lighting-08-studio-v2-sharp-640-v1.webp",
        "width": 640
      },
      {
        "src": "lighting-08-studio-v2-sharp-v1.webp",
        "width": 1254
      },
      {
        "src": "lighting-08-studio-v2-sharp-1600-v1.webp",
        "width": 1600
      },
      {
        "src": "lighting-08-studio-v2-hq2x-v1.webp",
        "width": 2508
      }
    ]
  },
  "lighting-11-studio-v2.webp": {
    "src": "lighting-11-studio-v2-hq2x-v1.webp",
    "displaySrc": "lighting-11-studio-v2-sharp-v1.webp",
    "width": 2508,
    "height": 2508,
    "originalWidth": 1254,
    "originalHeight": 1254,
    "sources": [
      {
        "src": "lighting-11-studio-v2-sharp-640-v1.webp",
        "width": 640
      },
      {
        "src": "lighting-11-studio-v2-sharp-v1.webp",
        "width": 1254
      },
      {
        "src": "lighting-11-studio-v2-sharp-1600-v1.webp",
        "width": 1600
      },
      {
        "src": "lighting-11-studio-v2-hq2x-v1.webp",
        "width": 2508
      }
    ]
  },
  "lighting-12-studio-v2.webp": {
    "src": "lighting-12-studio-v2-hq2x-v1.webp",
    "displaySrc": "lighting-12-studio-v2-sharp-v1.webp",
    "width": 2508,
    "height": 2508,
    "originalWidth": 1254,
    "originalHeight": 1254,
    "sources": [
      {
        "src": "lighting-12-studio-v2-sharp-640-v1.webp",
        "width": 640
      },
      {
        "src": "lighting-12-studio-v2-sharp-v1.webp",
        "width": 1254
      },
      {
        "src": "lighting-12-studio-v2-sharp-1600-v1.webp",
        "width": 1600
      },
      {
        "src": "lighting-12-studio-v2-hq2x-v1.webp",
        "width": 2508
      }
    ]
  },
  "lighting-13-studio-v2.webp": {
    "src": "lighting-13-studio-v2-hq2x-v1.webp",
    "displaySrc": "lighting-13-studio-v2-sharp-v1.webp",
    "width": 2508,
    "height": 2508,
    "originalWidth": 1254,
    "originalHeight": 1254,
    "sources": [
      {
        "src": "lighting-13-studio-v2-sharp-640-v1.webp",
        "width": 640
      },
      {
        "src": "lighting-13-studio-v2-sharp-v1.webp",
        "width": 1254
      },
      {
        "src": "lighting-13-studio-v2-sharp-1600-v1.webp",
        "width": 1600
      },
      {
        "src": "lighting-13-studio-v2-hq2x-v1.webp",
        "width": 2508
      }
    ]
  },
  "lighting-14-studio-v2.webp": {
    "src": "lighting-14-studio-v2-hq2x-v1.webp",
    "displaySrc": "lighting-14-studio-v2-sharp-v1.webp",
    "width": 2508,
    "height": 2508,
    "originalWidth": 1254,
    "originalHeight": 1254,
    "sources": [
      {
        "src": "lighting-14-studio-v2-sharp-640-v1.webp",
        "width": 640
      },
      {
        "src": "lighting-14-studio-v2-sharp-v1.webp",
        "width": 1254
      },
      {
        "src": "lighting-14-studio-v2-sharp-1600-v1.webp",
        "width": 1600
      },
      {
        "src": "lighting-14-studio-v2-hq2x-v1.webp",
        "width": 2508
      }
    ]
  },
  "lighting-15-studio-v2.webp": {
    "src": "lighting-15-studio-v2-hq2x-v1.webp",
    "displaySrc": "lighting-15-studio-v2-sharp-v1.webp",
    "width": 2508,
    "height": 2508,
    "originalWidth": 1254,
    "originalHeight": 1254,
    "sources": [
      {
        "src": "lighting-15-studio-v2-sharp-640-v1.webp",
        "width": 640
      },
      {
        "src": "lighting-15-studio-v2-sharp-v1.webp",
        "width": 1254
      },
      {
        "src": "lighting-15-studio-v2-sharp-1600-v1.webp",
        "width": 1600
      },
      {
        "src": "lighting-15-studio-v2-hq2x-v1.webp",
        "width": 2508
      }
    ]
  },
  "lighting-16-studio-v2.webp": {
    "src": "lighting-16-studio-v2-hq2x-v1.webp",
    "displaySrc": "lighting-16-studio-v2-sharp-v1.webp",
    "width": 2508,
    "height": 2508,
    "originalWidth": 1254,
    "originalHeight": 1254,
    "sources": [
      {
        "src": "lighting-16-studio-v2-sharp-640-v1.webp",
        "width": 640
      },
      {
        "src": "lighting-16-studio-v2-sharp-v1.webp",
        "width": 1254
      },
      {
        "src": "lighting-16-studio-v2-sharp-1600-v1.webp",
        "width": 1600
      },
      {
        "src": "lighting-16-studio-v2-hq2x-v1.webp",
        "width": 2508
      }
    ]
  },
  "lighting-17-studio-v2.webp": {
    "src": "lighting-17-studio-v2-hq2x-v1.webp",
    "displaySrc": "lighting-17-studio-v2-sharp-v1.webp",
    "width": 2508,
    "height": 2508,
    "originalWidth": 1254,
    "originalHeight": 1254,
    "sources": [
      {
        "src": "lighting-17-studio-v2-sharp-640-v1.webp",
        "width": 640
      },
      {
        "src": "lighting-17-studio-v2-sharp-v1.webp",
        "width": 1254
      },
      {
        "src": "lighting-17-studio-v2-sharp-1600-v1.webp",
        "width": 1600
      },
      {
        "src": "lighting-17-studio-v2-hq2x-v1.webp",
        "width": 2508
      }
    ]
  },
  "lighting-18-studio-v2.webp": {
    "src": "lighting-18-studio-v2-hq2x-v1.webp",
    "displaySrc": "lighting-18-studio-v2-sharp-v1.webp",
    "width": 2508,
    "height": 2508,
    "originalWidth": 1254,
    "originalHeight": 1254,
    "sources": [
      {
        "src": "lighting-18-studio-v2-sharp-640-v1.webp",
        "width": 640
      },
      {
        "src": "lighting-18-studio-v2-sharp-v1.webp",
        "width": 1254
      },
      {
        "src": "lighting-18-studio-v2-sharp-1600-v1.webp",
        "width": 1600
      },
      {
        "src": "lighting-18-studio-v2-hq2x-v1.webp",
        "width": 2508
      }
    ]
  },
  "lighting-19-studio-v2.webp": {
    "src": "lighting-19-studio-v2-hq2x-v1.webp",
    "displaySrc": "lighting-19-studio-v2-sharp-v1.webp",
    "width": 2508,
    "height": 2508,
    "originalWidth": 1254,
    "originalHeight": 1254,
    "sources": [
      {
        "src": "lighting-19-studio-v2-sharp-640-v1.webp",
        "width": 640
      },
      {
        "src": "lighting-19-studio-v2-sharp-v1.webp",
        "width": 1254
      },
      {
        "src": "lighting-19-studio-v2-sharp-1600-v1.webp",
        "width": 1600
      },
      {
        "src": "lighting-19-studio-v2-hq2x-v1.webp",
        "width": 2508
      }
    ]
  },
  "lighting-20-studio-v2.webp": {
    "src": "lighting-20-studio-v2-hq2x-v1.webp",
    "displaySrc": "lighting-20-studio-v2-sharp-v1.webp",
    "width": 2508,
    "height": 2508,
    "originalWidth": 1254,
    "originalHeight": 1254,
    "sources": [
      {
        "src": "lighting-20-studio-v2-sharp-640-v1.webp",
        "width": 640
      },
      {
        "src": "lighting-20-studio-v2-sharp-v1.webp",
        "width": 1254
      },
      {
        "src": "lighting-20-studio-v2-sharp-1600-v1.webp",
        "width": 1600
      },
      {
        "src": "lighting-20-studio-v2-hq2x-v1.webp",
        "width": 2508
      }
    ]
  },
  "lighting-02-life-01-v4.webp": {
    "src": "lighting-02-life-01-v4-hq2x-v1.webp",
    "displaySrc": "lighting-02-life-01-v4-sharp-v1.webp",
    "width": 2244,
    "height": 2804,
    "originalWidth": 1122,
    "originalHeight": 1402,
    "sources": [
      {
        "src": "lighting-02-life-01-v4-sharp-640-v1.webp",
        "width": 640
      },
      {
        "src": "lighting-02-life-01-v4-sharp-v1.webp",
        "width": 1122
      },
      {
        "src": "lighting-02-life-01-v4-sharp-1600-v1.webp",
        "width": 1600
      },
      {
        "src": "lighting-02-life-01-v4-hq2x-v1.webp",
        "width": 2244
      }
    ]
  },
  "lighting-03-life-01-v4.webp": {
    "src": "lighting-03-life-01-v4-hq2x-v1.webp",
    "displaySrc": "lighting-03-life-01-v4-sharp-v1.webp",
    "width": 2244,
    "height": 2804,
    "originalWidth": 1122,
    "originalHeight": 1402,
    "sources": [
      {
        "src": "lighting-03-life-01-v4-sharp-640-v1.webp",
        "width": 640
      },
      {
        "src": "lighting-03-life-01-v4-sharp-v1.webp",
        "width": 1122
      },
      {
        "src": "lighting-03-life-01-v4-sharp-1600-v1.webp",
        "width": 1600
      },
      {
        "src": "lighting-03-life-01-v4-hq2x-v1.webp",
        "width": 2244
      }
    ]
  },
  "lighting-04-life-01-v4.webp": {
    "src": "lighting-04-life-01-v4-hq2x-v1.webp",
    "displaySrc": "lighting-04-life-01-v4-sharp-v1.webp",
    "width": 2244,
    "height": 2804,
    "originalWidth": 1122,
    "originalHeight": 1402,
    "sources": [
      {
        "src": "lighting-04-life-01-v4-sharp-640-v1.webp",
        "width": 640
      },
      {
        "src": "lighting-04-life-01-v4-sharp-v1.webp",
        "width": 1122
      },
      {
        "src": "lighting-04-life-01-v4-sharp-1600-v1.webp",
        "width": 1600
      },
      {
        "src": "lighting-04-life-01-v4-hq2x-v1.webp",
        "width": 2244
      }
    ]
  },
  "lighting-07-life-01-v4.webp": {
    "src": "lighting-07-life-01-v4-hq2x-v1.webp",
    "displaySrc": "lighting-07-life-01-v4-sharp-v1.webp",
    "width": 2244,
    "height": 2804,
    "originalWidth": 1122,
    "originalHeight": 1402,
    "sources": [
      {
        "src": "lighting-07-life-01-v4-sharp-640-v1.webp",
        "width": 640
      },
      {
        "src": "lighting-07-life-01-v4-sharp-v1.webp",
        "width": 1122
      },
      {
        "src": "lighting-07-life-01-v4-sharp-1600-v1.webp",
        "width": 1600
      },
      {
        "src": "lighting-07-life-01-v4-hq2x-v1.webp",
        "width": 2244
      }
    ]
  },
  "lighting-11-life-01-v4.webp": {
    "src": "lighting-11-life-01-v4-hq2x-v1.webp",
    "displaySrc": "lighting-11-life-01-v4-sharp-v1.webp",
    "width": 2244,
    "height": 2804,
    "originalWidth": 1122,
    "originalHeight": 1402,
    "sources": [
      {
        "src": "lighting-11-life-01-v4-sharp-640-v1.webp",
        "width": 640
      },
      {
        "src": "lighting-11-life-01-v4-sharp-v1.webp",
        "width": 1122
      },
      {
        "src": "lighting-11-life-01-v4-sharp-1600-v1.webp",
        "width": 1600
      },
      {
        "src": "lighting-11-life-01-v4-hq2x-v1.webp",
        "width": 2244
      }
    ]
  },
  "lighting-12-life-01-v4.webp": {
    "src": "lighting-12-life-01-v4-hq2x-v1.webp",
    "displaySrc": "lighting-12-life-01-v4-sharp-v1.webp",
    "width": 2244,
    "height": 2804,
    "originalWidth": 1122,
    "originalHeight": 1402,
    "sources": [
      {
        "src": "lighting-12-life-01-v4-sharp-640-v1.webp",
        "width": 640
      },
      {
        "src": "lighting-12-life-01-v4-sharp-v1.webp",
        "width": 1122
      },
      {
        "src": "lighting-12-life-01-v4-sharp-1600-v1.webp",
        "width": 1600
      },
      {
        "src": "lighting-12-life-01-v4-hq2x-v1.webp",
        "width": 2244
      }
    ]
  },
  "lighting-13-life-01-v4.webp": {
    "src": "lighting-13-life-01-v4-hq2x-v1.webp",
    "displaySrc": "lighting-13-life-01-v4-sharp-v1.webp",
    "width": 2244,
    "height": 2804,
    "originalWidth": 1122,
    "originalHeight": 1402,
    "sources": [
      {
        "src": "lighting-13-life-01-v4-sharp-640-v1.webp",
        "width": 640
      },
      {
        "src": "lighting-13-life-01-v4-sharp-v1.webp",
        "width": 1122
      },
      {
        "src": "lighting-13-life-01-v4-sharp-1600-v1.webp",
        "width": 1600
      },
      {
        "src": "lighting-13-life-01-v4-hq2x-v1.webp",
        "width": 2244
      }
    ]
  },
  "lighting-05-life-01-v4.webp": {
    "src": "lighting-05-life-01-v4-hq2x-v1.webp",
    "displaySrc": "lighting-05-life-01-v4-sharp-v1.webp",
    "width": 2244,
    "height": 2804,
    "originalWidth": 1122,
    "originalHeight": 1402,
    "sources": [
      {
        "src": "lighting-05-life-01-v4-sharp-640-v1.webp",
        "width": 640
      },
      {
        "src": "lighting-05-life-01-v4-sharp-v1.webp",
        "width": 1122
      },
      {
        "src": "lighting-05-life-01-v4-sharp-1600-v1.webp",
        "width": 1600
      },
      {
        "src": "lighting-05-life-01-v4-hq2x-v1.webp",
        "width": 2244
      }
    ]
  },
  "lighting-06-life-01-v4.webp": {
    "src": "lighting-06-life-01-v4-hq2x-v1.webp",
    "displaySrc": "lighting-06-life-01-v4-sharp-v1.webp",
    "width": 2244,
    "height": 2804,
    "originalWidth": 1122,
    "originalHeight": 1402,
    "sources": [
      {
        "src": "lighting-06-life-01-v4-sharp-640-v1.webp",
        "width": 640
      },
      {
        "src": "lighting-06-life-01-v4-sharp-v1.webp",
        "width": 1122
      },
      {
        "src": "lighting-06-life-01-v4-sharp-1600-v1.webp",
        "width": 1600
      },
      {
        "src": "lighting-06-life-01-v4-hq2x-v1.webp",
        "width": 2244
      }
    ]
  },
  "lighting-08-life-01-v4.webp": {
    "src": "lighting-08-life-01-v4-hq2x-v1.webp",
    "displaySrc": "lighting-08-life-01-v4-sharp-v1.webp",
    "width": 2244,
    "height": 2804,
    "originalWidth": 1122,
    "originalHeight": 1402,
    "sources": [
      {
        "src": "lighting-08-life-01-v4-sharp-640-v1.webp",
        "width": 640
      },
      {
        "src": "lighting-08-life-01-v4-sharp-v1.webp",
        "width": 1122
      },
      {
        "src": "lighting-08-life-01-v4-sharp-1600-v1.webp",
        "width": 1600
      },
      {
        "src": "lighting-08-life-01-v4-hq2x-v1.webp",
        "width": 2244
      }
    ]
  },
  "lighting-14-life-01-v4.webp": {
    "src": "lighting-14-life-01-v4-hq2x-v1.webp",
    "displaySrc": "lighting-14-life-01-v4-sharp-v1.webp",
    "width": 2244,
    "height": 2804,
    "originalWidth": 1122,
    "originalHeight": 1402,
    "sources": [
      {
        "src": "lighting-14-life-01-v4-sharp-640-v1.webp",
        "width": 640
      },
      {
        "src": "lighting-14-life-01-v4-sharp-v1.webp",
        "width": 1122
      },
      {
        "src": "lighting-14-life-01-v4-sharp-1600-v1.webp",
        "width": 1600
      },
      {
        "src": "lighting-14-life-01-v4-hq2x-v1.webp",
        "width": 2244
      }
    ]
  },
  "lighting-15-life-01-v4.webp": {
    "src": "lighting-15-life-01-v4-hq2x-v1.webp",
    "displaySrc": "lighting-15-life-01-v4-sharp-v1.webp",
    "width": 2244,
    "height": 2804,
    "originalWidth": 1122,
    "originalHeight": 1402,
    "sources": [
      {
        "src": "lighting-15-life-01-v4-sharp-640-v1.webp",
        "width": 640
      },
      {
        "src": "lighting-15-life-01-v4-sharp-v1.webp",
        "width": 1122
      },
      {
        "src": "lighting-15-life-01-v4-sharp-1600-v1.webp",
        "width": 1600
      },
      {
        "src": "lighting-15-life-01-v4-hq2x-v1.webp",
        "width": 2244
      }
    ]
  },
  "lighting-16-life-01-v4.webp": {
    "src": "lighting-16-life-01-v4-hq2x-v1.webp",
    "displaySrc": "lighting-16-life-01-v4-sharp-v1.webp",
    "width": 2244,
    "height": 2804,
    "originalWidth": 1122,
    "originalHeight": 1402,
    "sources": [
      {
        "src": "lighting-16-life-01-v4-sharp-640-v1.webp",
        "width": 640
      },
      {
        "src": "lighting-16-life-01-v4-sharp-v1.webp",
        "width": 1122
      },
      {
        "src": "lighting-16-life-01-v4-sharp-1600-v1.webp",
        "width": 1600
      },
      {
        "src": "lighting-16-life-01-v4-hq2x-v1.webp",
        "width": 2244
      }
    ]
  },
  "lighting-17-life-01-v4.webp": {
    "src": "lighting-17-life-01-v4-hq2x-v1.webp",
    "displaySrc": "lighting-17-life-01-v4-sharp-v1.webp",
    "width": 2244,
    "height": 2804,
    "originalWidth": 1122,
    "originalHeight": 1402,
    "sources": [
      {
        "src": "lighting-17-life-01-v4-sharp-640-v1.webp",
        "width": 640
      },
      {
        "src": "lighting-17-life-01-v4-sharp-v1.webp",
        "width": 1122
      },
      {
        "src": "lighting-17-life-01-v4-sharp-1600-v1.webp",
        "width": 1600
      },
      {
        "src": "lighting-17-life-01-v4-hq2x-v1.webp",
        "width": 2244
      }
    ]
  },
  "lighting-18-life-01-v4.webp": {
    "src": "lighting-18-life-01-v4-hq2x-v1.webp",
    "displaySrc": "lighting-18-life-01-v4-sharp-v1.webp",
    "width": 2244,
    "height": 2804,
    "originalWidth": 1122,
    "originalHeight": 1402,
    "sources": [
      {
        "src": "lighting-18-life-01-v4-sharp-640-v1.webp",
        "width": 640
      },
      {
        "src": "lighting-18-life-01-v4-sharp-v1.webp",
        "width": 1122
      },
      {
        "src": "lighting-18-life-01-v4-sharp-1600-v1.webp",
        "width": 1600
      },
      {
        "src": "lighting-18-life-01-v4-hq2x-v1.webp",
        "width": 2244
      }
    ]
  },
  "lighting-19-life-01-v4.webp": {
    "src": "lighting-19-life-01-v4-hq2x-v1.webp",
    "displaySrc": "lighting-19-life-01-v4-sharp-v1.webp",
    "width": 2244,
    "height": 2804,
    "originalWidth": 1122,
    "originalHeight": 1402,
    "sources": [
      {
        "src": "lighting-19-life-01-v4-sharp-640-v1.webp",
        "width": 640
      },
      {
        "src": "lighting-19-life-01-v4-sharp-v1.webp",
        "width": 1122
      },
      {
        "src": "lighting-19-life-01-v4-sharp-1600-v1.webp",
        "width": 1600
      },
      {
        "src": "lighting-19-life-01-v4-hq2x-v1.webp",
        "width": 2244
      }
    ]
  },
  "lighting-20-life-01-v4.webp": {
    "src": "lighting-20-life-01-v4-hq2x-v1.webp",
    "displaySrc": "lighting-20-life-01-v4-sharp-v1.webp",
    "width": 2244,
    "height": 2804,
    "originalWidth": 1122,
    "originalHeight": 1402,
    "sources": [
      {
        "src": "lighting-20-life-01-v4-sharp-640-v1.webp",
        "width": 640
      },
      {
        "src": "lighting-20-life-01-v4-sharp-v1.webp",
        "width": 1122
      },
      {
        "src": "lighting-20-life-01-v4-sharp-1600-v1.webp",
        "width": 1600
      },
      {
        "src": "lighting-20-life-01-v4-hq2x-v1.webp",
        "width": 2244
      }
    ]
  },
  "lighting-01-life-02-v3.webp": {
    "src": "lighting-01-life-02-v3-hq2x-v1.webp",
    "displaySrc": "lighting-01-life-02-v3-sharp-v1.webp",
    "width": 2244,
    "height": 2804,
    "originalWidth": 1122,
    "originalHeight": 1402,
    "sources": [
      {
        "src": "lighting-01-life-02-v3-sharp-640-v1.webp",
        "width": 640
      },
      {
        "src": "lighting-01-life-02-v3-sharp-v1.webp",
        "width": 1122
      },
      {
        "src": "lighting-01-life-02-v3-sharp-1600-v1.webp",
        "width": 1600
      },
      {
        "src": "lighting-01-life-02-v3-hq2x-v1.webp",
        "width": 2244
      }
    ]
  },
  "lighting-02-life-02-v4.webp": {
    "src": "lighting-02-life-02-v4-hq2x-v1.webp",
    "displaySrc": "lighting-02-life-02-v4-sharp-v1.webp",
    "width": 2244,
    "height": 2804,
    "originalWidth": 1122,
    "originalHeight": 1402,
    "sources": [
      {
        "src": "lighting-02-life-02-v4-sharp-640-v1.webp",
        "width": 640
      },
      {
        "src": "lighting-02-life-02-v4-sharp-v1.webp",
        "width": 1122
      },
      {
        "src": "lighting-02-life-02-v4-sharp-1600-v1.webp",
        "width": 1600
      },
      {
        "src": "lighting-02-life-02-v4-hq2x-v1.webp",
        "width": 2244
      }
    ]
  },
  "lighting-03-life-02-v4.webp": {
    "src": "lighting-03-life-02-v4-hq2x-v1.webp",
    "displaySrc": "lighting-03-life-02-v4-sharp-v1.webp",
    "width": 2244,
    "height": 2804,
    "originalWidth": 1122,
    "originalHeight": 1402,
    "sources": [
      {
        "src": "lighting-03-life-02-v4-sharp-640-v1.webp",
        "width": 640
      },
      {
        "src": "lighting-03-life-02-v4-sharp-v1.webp",
        "width": 1122
      },
      {
        "src": "lighting-03-life-02-v4-sharp-1600-v1.webp",
        "width": 1600
      },
      {
        "src": "lighting-03-life-02-v4-hq2x-v1.webp",
        "width": 2244
      }
    ]
  },
  "lighting-04-life-02-v4.webp": {
    "src": "lighting-04-life-02-v4-hq2x-v1.webp",
    "displaySrc": "lighting-04-life-02-v4-sharp-v1.webp",
    "width": 2244,
    "height": 2804,
    "originalWidth": 1122,
    "originalHeight": 1402,
    "sources": [
      {
        "src": "lighting-04-life-02-v4-sharp-640-v1.webp",
        "width": 640
      },
      {
        "src": "lighting-04-life-02-v4-sharp-v1.webp",
        "width": 1122
      },
      {
        "src": "lighting-04-life-02-v4-sharp-1600-v1.webp",
        "width": 1600
      },
      {
        "src": "lighting-04-life-02-v4-hq2x-v1.webp",
        "width": 2244
      }
    ]
  },
  "lighting-05-life-02-v4.webp": {
    "src": "lighting-05-life-02-v4-hq2x-v1.webp",
    "displaySrc": "lighting-05-life-02-v4-sharp-v1.webp",
    "width": 2244,
    "height": 2804,
    "originalWidth": 1122,
    "originalHeight": 1402,
    "sources": [
      {
        "src": "lighting-05-life-02-v4-sharp-640-v1.webp",
        "width": 640
      },
      {
        "src": "lighting-05-life-02-v4-sharp-v1.webp",
        "width": 1122
      },
      {
        "src": "lighting-05-life-02-v4-sharp-1600-v1.webp",
        "width": 1600
      },
      {
        "src": "lighting-05-life-02-v4-hq2x-v1.webp",
        "width": 2244
      }
    ]
  },
  "lighting-06-life-02-v4.webp": {
    "src": "lighting-06-life-02-v4-hq2x-v1.webp",
    "displaySrc": "lighting-06-life-02-v4-sharp-v1.webp",
    "width": 2244,
    "height": 2804,
    "originalWidth": 1122,
    "originalHeight": 1402,
    "sources": [
      {
        "src": "lighting-06-life-02-v4-sharp-640-v1.webp",
        "width": 640
      },
      {
        "src": "lighting-06-life-02-v4-sharp-v1.webp",
        "width": 1122
      },
      {
        "src": "lighting-06-life-02-v4-sharp-1600-v1.webp",
        "width": 1600
      },
      {
        "src": "lighting-06-life-02-v4-hq2x-v1.webp",
        "width": 2244
      }
    ]
  },
  "lighting-08-life-02-v4.webp": {
    "src": "lighting-08-life-02-v4-hq2x-v1.webp",
    "displaySrc": "lighting-08-life-02-v4-sharp-v1.webp",
    "width": 2244,
    "height": 2804,
    "originalWidth": 1122,
    "originalHeight": 1402,
    "sources": [
      {
        "src": "lighting-08-life-02-v4-sharp-640-v1.webp",
        "width": 640
      },
      {
        "src": "lighting-08-life-02-v4-sharp-v1.webp",
        "width": 1122
      },
      {
        "src": "lighting-08-life-02-v4-sharp-1600-v1.webp",
        "width": 1600
      },
      {
        "src": "lighting-08-life-02-v4-hq2x-v1.webp",
        "width": 2244
      }
    ]
  },
  "lighting-09-life-02-v4.webp": {
    "src": "lighting-09-life-02-v4-hq2x-v1.webp",
    "displaySrc": "lighting-09-life-02-v4-sharp-v1.webp",
    "width": 2244,
    "height": 2804,
    "originalWidth": 1122,
    "originalHeight": 1402,
    "sources": [
      {
        "src": "lighting-09-life-02-v4-sharp-640-v1.webp",
        "width": 640
      },
      {
        "src": "lighting-09-life-02-v4-sharp-v1.webp",
        "width": 1122
      },
      {
        "src": "lighting-09-life-02-v4-sharp-1600-v1.webp",
        "width": 1600
      },
      {
        "src": "lighting-09-life-02-v4-hq2x-v1.webp",
        "width": 2244
      }
    ]
  },
  "lighting-11-life-02-v4.webp": {
    "src": "lighting-11-life-02-v4-hq2x-v1.webp",
    "displaySrc": "lighting-11-life-02-v4-sharp-v1.webp",
    "width": 2244,
    "height": 2804,
    "originalWidth": 1122,
    "originalHeight": 1402,
    "sources": [
      {
        "src": "lighting-11-life-02-v4-sharp-640-v1.webp",
        "width": 640
      },
      {
        "src": "lighting-11-life-02-v4-sharp-v1.webp",
        "width": 1122
      },
      {
        "src": "lighting-11-life-02-v4-sharp-1600-v1.webp",
        "width": 1600
      },
      {
        "src": "lighting-11-life-02-v4-hq2x-v1.webp",
        "width": 2244
      }
    ]
  },
  "lighting-13-life-02-v4.webp": {
    "src": "lighting-13-life-02-v4-hq2x-v1.webp",
    "displaySrc": "lighting-13-life-02-v4-sharp-v1.webp",
    "width": 2244,
    "height": 2804,
    "originalWidth": 1122,
    "originalHeight": 1402,
    "sources": [
      {
        "src": "lighting-13-life-02-v4-sharp-640-v1.webp",
        "width": 640
      },
      {
        "src": "lighting-13-life-02-v4-sharp-v1.webp",
        "width": 1122
      },
      {
        "src": "lighting-13-life-02-v4-sharp-1600-v1.webp",
        "width": 1600
      },
      {
        "src": "lighting-13-life-02-v4-hq2x-v1.webp",
        "width": 2244
      }
    ]
  },
  "lighting-12-life-02-v4.webp": {
    "src": "lighting-12-life-02-v4-hq2x-v1.webp",
    "displaySrc": "lighting-12-life-02-v4-sharp-v1.webp",
    "width": 2244,
    "height": 2804,
    "originalWidth": 1122,
    "originalHeight": 1402,
    "sources": [
      {
        "src": "lighting-12-life-02-v4-sharp-640-v1.webp",
        "width": 640
      },
      {
        "src": "lighting-12-life-02-v4-sharp-v1.webp",
        "width": 1122
      },
      {
        "src": "lighting-12-life-02-v4-sharp-1600-v1.webp",
        "width": 1600
      },
      {
        "src": "lighting-12-life-02-v4-hq2x-v1.webp",
        "width": 2244
      }
    ]
  },
  "lighting-14-life-02-v4.webp": {
    "src": "lighting-14-life-02-v4-hq2x-v1.webp",
    "displaySrc": "lighting-14-life-02-v4-sharp-v1.webp",
    "width": 2244,
    "height": 2804,
    "originalWidth": 1122,
    "originalHeight": 1402,
    "sources": [
      {
        "src": "lighting-14-life-02-v4-sharp-640-v1.webp",
        "width": 640
      },
      {
        "src": "lighting-14-life-02-v4-sharp-v1.webp",
        "width": 1122
      },
      {
        "src": "lighting-14-life-02-v4-sharp-1600-v1.webp",
        "width": 1600
      },
      {
        "src": "lighting-14-life-02-v4-hq2x-v1.webp",
        "width": 2244
      }
    ]
  },
  "lighting-16-life-02-v4.webp": {
    "src": "lighting-16-life-02-v4-hq2x-v1.webp",
    "displaySrc": "lighting-16-life-02-v4-sharp-v1.webp",
    "width": 2244,
    "height": 2804,
    "originalWidth": 1122,
    "originalHeight": 1402,
    "sources": [
      {
        "src": "lighting-16-life-02-v4-sharp-640-v1.webp",
        "width": 640
      },
      {
        "src": "lighting-16-life-02-v4-sharp-v1.webp",
        "width": 1122
      },
      {
        "src": "lighting-16-life-02-v4-sharp-1600-v1.webp",
        "width": 1600
      },
      {
        "src": "lighting-16-life-02-v4-hq2x-v1.webp",
        "width": 2244
      }
    ]
  },
  "lighting-17-life-02-v4.webp": {
    "src": "lighting-17-life-02-v4-hq2x-v1.webp",
    "displaySrc": "lighting-17-life-02-v4-sharp-v1.webp",
    "width": 2244,
    "height": 2804,
    "originalWidth": 1122,
    "originalHeight": 1402,
    "sources": [
      {
        "src": "lighting-17-life-02-v4-sharp-640-v1.webp",
        "width": 640
      },
      {
        "src": "lighting-17-life-02-v4-sharp-v1.webp",
        "width": 1122
      },
      {
        "src": "lighting-17-life-02-v4-sharp-1600-v1.webp",
        "width": 1600
      },
      {
        "src": "lighting-17-life-02-v4-hq2x-v1.webp",
        "width": 2244
      }
    ]
  },
  "lighting-18-life-02-v4.webp": {
    "src": "lighting-18-life-02-v4-hq2x-v1.webp",
    "displaySrc": "lighting-18-life-02-v4-sharp-v1.webp",
    "width": 2244,
    "height": 2804,
    "originalWidth": 1122,
    "originalHeight": 1402,
    "sources": [
      {
        "src": "lighting-18-life-02-v4-sharp-640-v1.webp",
        "width": 640
      },
      {
        "src": "lighting-18-life-02-v4-sharp-v1.webp",
        "width": 1122
      },
      {
        "src": "lighting-18-life-02-v4-sharp-1600-v1.webp",
        "width": 1600
      },
      {
        "src": "lighting-18-life-02-v4-hq2x-v1.webp",
        "width": 2244
      }
    ]
  },
  "lighting-19-life-02-v4.webp": {
    "src": "lighting-19-life-02-v4-hq2x-v1.webp",
    "displaySrc": "lighting-19-life-02-v4-sharp-v1.webp",
    "width": 2244,
    "height": 2804,
    "originalWidth": 1122,
    "originalHeight": 1402,
    "sources": [
      {
        "src": "lighting-19-life-02-v4-sharp-640-v1.webp",
        "width": 640
      },
      {
        "src": "lighting-19-life-02-v4-sharp-v1.webp",
        "width": 1122
      },
      {
        "src": "lighting-19-life-02-v4-sharp-1600-v1.webp",
        "width": 1600
      },
      {
        "src": "lighting-19-life-02-v4-hq2x-v1.webp",
        "width": 2244
      }
    ]
  },
  "lighting-20-life-02-v4.webp": {
    "src": "lighting-20-life-02-v4-hq2x-v1.webp",
    "displaySrc": "lighting-20-life-02-v4-sharp-v1.webp",
    "width": 2244,
    "height": 2804,
    "originalWidth": 1122,
    "originalHeight": 1402,
    "sources": [
      {
        "src": "lighting-20-life-02-v4-sharp-640-v1.webp",
        "width": 640
      },
      {
        "src": "lighting-20-life-02-v4-sharp-v1.webp",
        "width": 1122
      },
      {
        "src": "lighting-20-life-02-v4-sharp-1600-v1.webp",
        "width": 1600
      },
      {
        "src": "lighting-20-life-02-v4-hq2x-v1.webp",
        "width": 2244
      }
    ]
  },
  "lighting-07-life-02-v4.webp": {
    "src": "lighting-07-life-02-v4-hq2x-v1.webp",
    "displaySrc": "lighting-07-life-02-v4-sharp-v1.webp",
    "width": 2244,
    "height": 2804,
    "originalWidth": 1122,
    "originalHeight": 1402,
    "sources": [
      {
        "src": "lighting-07-life-02-v4-sharp-640-v1.webp",
        "width": 640
      },
      {
        "src": "lighting-07-life-02-v4-sharp-v1.webp",
        "width": 1122
      },
      {
        "src": "lighting-07-life-02-v4-sharp-1600-v1.webp",
        "width": 1600
      },
      {
        "src": "lighting-07-life-02-v4-hq2x-v1.webp",
        "width": 2244
      }
    ]
  },
  "lighting-01-life-02-v4.webp": {
    "src": "lighting-01-life-02-v4-hq2x-v1.webp",
    "displaySrc": "lighting-01-life-02-v4-sharp-v1.webp",
    "width": 2244,
    "height": 2804,
    "originalWidth": 1122,
    "originalHeight": 1402,
    "sources": [
      {
        "src": "lighting-01-life-02-v4-sharp-640-v1.webp",
        "width": 640
      },
      {
        "src": "lighting-01-life-02-v4-sharp-v1.webp",
        "width": 1122
      },
      {
        "src": "lighting-01-life-02-v4-sharp-1600-v1.webp",
        "width": 1600
      },
      {
        "src": "lighting-01-life-02-v4-hq2x-v1.webp",
        "width": 2244
      }
    ]
  },
  "lighting-02-life-03-v3.webp": {
    "src": "lighting-02-life-03-v3-hq2x-v1.webp",
    "displaySrc": "lighting-02-life-03-v3-sharp-v1.webp",
    "width": 2244,
    "height": 2804,
    "originalWidth": 1122,
    "originalHeight": 1402,
    "sources": [
      {
        "src": "lighting-02-life-03-v3-sharp-640-v1.webp",
        "width": 640
      },
      {
        "src": "lighting-02-life-03-v3-sharp-v1.webp",
        "width": 1122
      },
      {
        "src": "lighting-02-life-03-v3-sharp-1600-v1.webp",
        "width": 1600
      },
      {
        "src": "lighting-02-life-03-v3-hq2x-v1.webp",
        "width": 2244
      }
    ]
  },
  "lighting-03-life-03-v3.webp": {
    "src": "lighting-03-life-03-v3-hq2x-v1.webp",
    "displaySrc": "lighting-03-life-03-v3-sharp-v1.webp",
    "width": 2244,
    "height": 2804,
    "originalWidth": 1122,
    "originalHeight": 1402,
    "sources": [
      {
        "src": "lighting-03-life-03-v3-sharp-640-v1.webp",
        "width": 640
      },
      {
        "src": "lighting-03-life-03-v3-sharp-v1.webp",
        "width": 1122
      },
      {
        "src": "lighting-03-life-03-v3-sharp-1600-v1.webp",
        "width": 1600
      },
      {
        "src": "lighting-03-life-03-v3-hq2x-v1.webp",
        "width": 2244
      }
    ]
  },
  "lighting-04-life-03-v3.webp": {
    "src": "lighting-04-life-03-v3-hq2x-v1.webp",
    "displaySrc": "lighting-04-life-03-v3-sharp-v1.webp",
    "width": 2244,
    "height": 2804,
    "originalWidth": 1122,
    "originalHeight": 1402,
    "sources": [
      {
        "src": "lighting-04-life-03-v3-sharp-640-v1.webp",
        "width": 640
      },
      {
        "src": "lighting-04-life-03-v3-sharp-v1.webp",
        "width": 1122
      },
      {
        "src": "lighting-04-life-03-v3-sharp-1600-v1.webp",
        "width": 1600
      },
      {
        "src": "lighting-04-life-03-v3-hq2x-v1.webp",
        "width": 2244
      }
    ]
  },
  "lighting-05-life-03-v3.webp": {
    "src": "lighting-05-life-03-v3-hq2x-v1.webp",
    "displaySrc": "lighting-05-life-03-v3-sharp-v1.webp",
    "width": 2244,
    "height": 2804,
    "originalWidth": 1122,
    "originalHeight": 1402,
    "sources": [
      {
        "src": "lighting-05-life-03-v3-sharp-640-v1.webp",
        "width": 640
      },
      {
        "src": "lighting-05-life-03-v3-sharp-v1.webp",
        "width": 1122
      },
      {
        "src": "lighting-05-life-03-v3-sharp-1600-v1.webp",
        "width": 1600
      },
      {
        "src": "lighting-05-life-03-v3-hq2x-v1.webp",
        "width": 2244
      }
    ]
  },
  "lighting-06-life-03-v3.webp": {
    "src": "lighting-06-life-03-v3-hq2x-v1.webp",
    "displaySrc": "lighting-06-life-03-v3-sharp-v1.webp",
    "width": 2244,
    "height": 2804,
    "originalWidth": 1122,
    "originalHeight": 1402,
    "sources": [
      {
        "src": "lighting-06-life-03-v3-sharp-640-v1.webp",
        "width": 640
      },
      {
        "src": "lighting-06-life-03-v3-sharp-v1.webp",
        "width": 1122
      },
      {
        "src": "lighting-06-life-03-v3-sharp-1600-v1.webp",
        "width": 1600
      },
      {
        "src": "lighting-06-life-03-v3-hq2x-v1.webp",
        "width": 2244
      }
    ]
  },
  "lighting-08-life-03-v3.webp": {
    "src": "lighting-08-life-03-v3-hq2x-v1.webp",
    "displaySrc": "lighting-08-life-03-v3-sharp-v1.webp",
    "width": 2244,
    "height": 2804,
    "originalWidth": 1122,
    "originalHeight": 1402,
    "sources": [
      {
        "src": "lighting-08-life-03-v3-sharp-640-v1.webp",
        "width": 640
      },
      {
        "src": "lighting-08-life-03-v3-sharp-v1.webp",
        "width": 1122
      },
      {
        "src": "lighting-08-life-03-v3-sharp-1600-v1.webp",
        "width": 1600
      },
      {
        "src": "lighting-08-life-03-v3-hq2x-v1.webp",
        "width": 2244
      }
    ]
  },
  "lighting-09-life-03-v3.webp": {
    "src": "lighting-09-life-03-v3-hq2x-v1.webp",
    "displaySrc": "lighting-09-life-03-v3-sharp-v1.webp",
    "width": 2244,
    "height": 2804,
    "originalWidth": 1122,
    "originalHeight": 1402,
    "sources": [
      {
        "src": "lighting-09-life-03-v3-sharp-640-v1.webp",
        "width": 640
      },
      {
        "src": "lighting-09-life-03-v3-sharp-v1.webp",
        "width": 1122
      },
      {
        "src": "lighting-09-life-03-v3-sharp-1600-v1.webp",
        "width": 1600
      },
      {
        "src": "lighting-09-life-03-v3-hq2x-v1.webp",
        "width": 2244
      }
    ]
  },
  "lighting-10-life-03-v3.webp": {
    "src": "lighting-10-life-03-v3-hq2x-v1.webp",
    "displaySrc": "lighting-10-life-03-v3-sharp-v1.webp",
    "width": 2244,
    "height": 2804,
    "originalWidth": 1122,
    "originalHeight": 1402,
    "sources": [
      {
        "src": "lighting-10-life-03-v3-sharp-640-v1.webp",
        "width": 640
      },
      {
        "src": "lighting-10-life-03-v3-sharp-v1.webp",
        "width": 1122
      },
      {
        "src": "lighting-10-life-03-v3-sharp-1600-v1.webp",
        "width": 1600
      },
      {
        "src": "lighting-10-life-03-v3-hq2x-v1.webp",
        "width": 2244
      }
    ]
  },
  "lighting-11-life-03-v3.webp": {
    "src": "lighting-11-life-03-v3-hq2x-v1.webp",
    "displaySrc": "lighting-11-life-03-v3-sharp-v1.webp",
    "width": 2244,
    "height": 2804,
    "originalWidth": 1122,
    "originalHeight": 1402,
    "sources": [
      {
        "src": "lighting-11-life-03-v3-sharp-640-v1.webp",
        "width": 640
      },
      {
        "src": "lighting-11-life-03-v3-sharp-v1.webp",
        "width": 1122
      },
      {
        "src": "lighting-11-life-03-v3-sharp-1600-v1.webp",
        "width": 1600
      },
      {
        "src": "lighting-11-life-03-v3-hq2x-v1.webp",
        "width": 2244
      }
    ]
  },
  "lighting-12-life-03-v3.webp": {
    "src": "lighting-12-life-03-v3-hq2x-v1.webp",
    "displaySrc": "lighting-12-life-03-v3-sharp-v1.webp",
    "width": 2244,
    "height": 2804,
    "originalWidth": 1122,
    "originalHeight": 1402,
    "sources": [
      {
        "src": "lighting-12-life-03-v3-sharp-640-v1.webp",
        "width": 640
      },
      {
        "src": "lighting-12-life-03-v3-sharp-v1.webp",
        "width": 1122
      },
      {
        "src": "lighting-12-life-03-v3-sharp-1600-v1.webp",
        "width": 1600
      },
      {
        "src": "lighting-12-life-03-v3-hq2x-v1.webp",
        "width": 2244
      }
    ]
  },
  "lighting-13-life-03-v3.webp": {
    "src": "lighting-13-life-03-v3-hq2x-v1.webp",
    "displaySrc": "lighting-13-life-03-v3-sharp-v1.webp",
    "width": 2244,
    "height": 2804,
    "originalWidth": 1122,
    "originalHeight": 1402,
    "sources": [
      {
        "src": "lighting-13-life-03-v3-sharp-640-v1.webp",
        "width": 640
      },
      {
        "src": "lighting-13-life-03-v3-sharp-v1.webp",
        "width": 1122
      },
      {
        "src": "lighting-13-life-03-v3-sharp-1600-v1.webp",
        "width": 1600
      },
      {
        "src": "lighting-13-life-03-v3-hq2x-v1.webp",
        "width": 2244
      }
    ]
  },
  "lighting-15-life-03-v3.webp": {
    "src": "lighting-15-life-03-v3-hq2x-v1.webp",
    "displaySrc": "lighting-15-life-03-v3-sharp-v1.webp",
    "width": 2244,
    "height": 2804,
    "originalWidth": 1122,
    "originalHeight": 1402,
    "sources": [
      {
        "src": "lighting-15-life-03-v3-sharp-640-v1.webp",
        "width": 640
      },
      {
        "src": "lighting-15-life-03-v3-sharp-v1.webp",
        "width": 1122
      },
      {
        "src": "lighting-15-life-03-v3-sharp-1600-v1.webp",
        "width": 1600
      },
      {
        "src": "lighting-15-life-03-v3-hq2x-v1.webp",
        "width": 2244
      }
    ]
  },
  "lighting-16-life-03-v3.webp": {
    "src": "lighting-16-life-03-v3-hq2x-v1.webp",
    "displaySrc": "lighting-16-life-03-v3-sharp-v1.webp",
    "width": 2244,
    "height": 2804,
    "originalWidth": 1122,
    "originalHeight": 1402,
    "sources": [
      {
        "src": "lighting-16-life-03-v3-sharp-640-v1.webp",
        "width": 640
      },
      {
        "src": "lighting-16-life-03-v3-sharp-v1.webp",
        "width": 1122
      },
      {
        "src": "lighting-16-life-03-v3-sharp-1600-v1.webp",
        "width": 1600
      },
      {
        "src": "lighting-16-life-03-v3-hq2x-v1.webp",
        "width": 2244
      }
    ]
  },
  "lighting-17-life-03-v3.webp": {
    "src": "lighting-17-life-03-v3-hq2x-v1.webp",
    "displaySrc": "lighting-17-life-03-v3-sharp-v1.webp",
    "width": 2244,
    "height": 2804,
    "originalWidth": 1122,
    "originalHeight": 1402,
    "sources": [
      {
        "src": "lighting-17-life-03-v3-sharp-640-v1.webp",
        "width": 640
      },
      {
        "src": "lighting-17-life-03-v3-sharp-v1.webp",
        "width": 1122
      },
      {
        "src": "lighting-17-life-03-v3-sharp-1600-v1.webp",
        "width": 1600
      },
      {
        "src": "lighting-17-life-03-v3-hq2x-v1.webp",
        "width": 2244
      }
    ]
  },
  "lighting-18-life-03-v3.webp": {
    "src": "lighting-18-life-03-v3-hq2x-v1.webp",
    "displaySrc": "lighting-18-life-03-v3-sharp-v1.webp",
    "width": 2244,
    "height": 2804,
    "originalWidth": 1122,
    "originalHeight": 1402,
    "sources": [
      {
        "src": "lighting-18-life-03-v3-sharp-640-v1.webp",
        "width": 640
      },
      {
        "src": "lighting-18-life-03-v3-sharp-v1.webp",
        "width": 1122
      },
      {
        "src": "lighting-18-life-03-v3-sharp-1600-v1.webp",
        "width": 1600
      },
      {
        "src": "lighting-18-life-03-v3-hq2x-v1.webp",
        "width": 2244
      }
    ]
  },
  "lighting-19-life-03-v3.webp": {
    "src": "lighting-19-life-03-v3-hq2x-v1.webp",
    "displaySrc": "lighting-19-life-03-v3-sharp-v1.webp",
    "width": 2244,
    "height": 2804,
    "originalWidth": 1122,
    "originalHeight": 1402,
    "sources": [
      {
        "src": "lighting-19-life-03-v3-sharp-640-v1.webp",
        "width": 640
      },
      {
        "src": "lighting-19-life-03-v3-sharp-v1.webp",
        "width": 1122
      },
      {
        "src": "lighting-19-life-03-v3-sharp-1600-v1.webp",
        "width": 1600
      },
      {
        "src": "lighting-19-life-03-v3-hq2x-v1.webp",
        "width": 2244
      }
    ]
  },
  "lighting-20-life-03-v3.webp": {
    "src": "lighting-20-life-03-v3-hq2x-v1.webp",
    "displaySrc": "lighting-20-life-03-v3-sharp-v1.webp",
    "width": 2244,
    "height": 2804,
    "originalWidth": 1122,
    "originalHeight": 1402,
    "sources": [
      {
        "src": "lighting-20-life-03-v3-sharp-640-v1.webp",
        "width": 640
      },
      {
        "src": "lighting-20-life-03-v3-sharp-v1.webp",
        "width": 1122
      },
      {
        "src": "lighting-20-life-03-v3-sharp-1600-v1.webp",
        "width": 1600
      },
      {
        "src": "lighting-20-life-03-v3-hq2x-v1.webp",
        "width": 2244
      }
    ]
  },
  "lighting-14-life-03-v3.webp": {
    "src": "lighting-14-life-03-v3-hq2x-v1.webp",
    "displaySrc": "lighting-14-life-03-v3-sharp-v1.webp",
    "width": 2244,
    "height": 2804,
    "originalWidth": 1122,
    "originalHeight": 1402,
    "sources": [
      {
        "src": "lighting-14-life-03-v3-sharp-640-v1.webp",
        "width": 640
      },
      {
        "src": "lighting-14-life-03-v3-sharp-v1.webp",
        "width": 1122
      },
      {
        "src": "lighting-14-life-03-v3-sharp-1600-v1.webp",
        "width": 1600
      },
      {
        "src": "lighting-14-life-03-v3-hq2x-v1.webp",
        "width": 2244
      }
    ]
  },
  "lighting-07-life-03-v3.webp": {
    "src": "lighting-07-life-03-v3-hq2x-v1.webp",
    "displaySrc": "lighting-07-life-03-v3-sharp-v1.webp",
    "width": 2244,
    "height": 2804,
    "originalWidth": 1122,
    "originalHeight": 1402,
    "sources": [
      {
        "src": "lighting-07-life-03-v3-sharp-640-v1.webp",
        "width": 640
      },
      {
        "src": "lighting-07-life-03-v3-sharp-v1.webp",
        "width": 1122
      },
      {
        "src": "lighting-07-life-03-v3-sharp-1600-v1.webp",
        "width": 1600
      },
      {
        "src": "lighting-07-life-03-v3-hq2x-v1.webp",
        "width": 2244
      }
    ]
  },
  "lighting-02-life-04-v3.webp": {
    "src": "lighting-02-life-04-v3-hq2x-v1.webp",
    "displaySrc": "lighting-02-life-04-v3-sharp-v1.webp",
    "width": 2244,
    "height": 2804,
    "originalWidth": 1122,
    "originalHeight": 1402,
    "sources": [
      {
        "src": "lighting-02-life-04-v3-sharp-640-v1.webp",
        "width": 640
      },
      {
        "src": "lighting-02-life-04-v3-sharp-v1.webp",
        "width": 1122
      },
      {
        "src": "lighting-02-life-04-v3-sharp-1600-v1.webp",
        "width": 1600
      },
      {
        "src": "lighting-02-life-04-v3-hq2x-v1.webp",
        "width": 2244
      }
    ]
  },
  "lighting-04-life-04-v3.webp": {
    "src": "lighting-04-life-04-v3-hq2x-v1.webp",
    "displaySrc": "lighting-04-life-04-v3-sharp-v1.webp",
    "width": 2244,
    "height": 2804,
    "originalWidth": 1122,
    "originalHeight": 1402,
    "sources": [
      {
        "src": "lighting-04-life-04-v3-sharp-640-v1.webp",
        "width": 640
      },
      {
        "src": "lighting-04-life-04-v3-sharp-v1.webp",
        "width": 1122
      },
      {
        "src": "lighting-04-life-04-v3-sharp-1600-v1.webp",
        "width": 1600
      },
      {
        "src": "lighting-04-life-04-v3-hq2x-v1.webp",
        "width": 2244
      }
    ]
  },
  "lighting-03-life-04-v3.webp": {
    "src": "lighting-03-life-04-v3-hq2x-v1.webp",
    "displaySrc": "lighting-03-life-04-v3-sharp-v1.webp",
    "width": 2244,
    "height": 2804,
    "originalWidth": 1122,
    "originalHeight": 1402,
    "sources": [
      {
        "src": "lighting-03-life-04-v3-sharp-640-v1.webp",
        "width": 640
      },
      {
        "src": "lighting-03-life-04-v3-sharp-v1.webp",
        "width": 1122
      },
      {
        "src": "lighting-03-life-04-v3-sharp-1600-v1.webp",
        "width": 1600
      },
      {
        "src": "lighting-03-life-04-v3-hq2x-v1.webp",
        "width": 2244
      }
    ]
  },
  "lighting-04-life-05-v3.webp": {
    "src": "lighting-04-life-05-v3-hq2x-v1.webp",
    "displaySrc": "lighting-04-life-05-v3-sharp-v1.webp",
    "width": 2244,
    "height": 2804,
    "originalWidth": 1122,
    "originalHeight": 1402,
    "sources": [
      {
        "src": "lighting-04-life-05-v3-sharp-640-v1.webp",
        "width": 640
      },
      {
        "src": "lighting-04-life-05-v3-sharp-v1.webp",
        "width": 1122
      },
      {
        "src": "lighting-04-life-05-v3-sharp-1600-v1.webp",
        "width": 1600
      },
      {
        "src": "lighting-04-life-05-v3-hq2x-v1.webp",
        "width": 2244
      }
    ]
  },
  "lighting-05-life-04-v3.webp": {
    "src": "lighting-05-life-04-v3-hq2x-v1.webp",
    "displaySrc": "lighting-05-life-04-v3-sharp-v1.webp",
    "width": 2244,
    "height": 2804,
    "originalWidth": 1122,
    "originalHeight": 1402,
    "sources": [
      {
        "src": "lighting-05-life-04-v3-sharp-640-v1.webp",
        "width": 640
      },
      {
        "src": "lighting-05-life-04-v3-sharp-v1.webp",
        "width": 1122
      },
      {
        "src": "lighting-05-life-04-v3-sharp-1600-v1.webp",
        "width": 1600
      },
      {
        "src": "lighting-05-life-04-v3-hq2x-v1.webp",
        "width": 2244
      }
    ]
  },
  "lighting-01-life-04-v3.webp": {
    "src": "lighting-01-life-04-v3-hq2x-v1.webp",
    "displaySrc": "lighting-01-life-04-v3-sharp-v1.webp",
    "width": 2244,
    "height": 2804,
    "originalWidth": 1122,
    "originalHeight": 1402,
    "sources": [
      {
        "src": "lighting-01-life-04-v3-sharp-640-v1.webp",
        "width": 640
      },
      {
        "src": "lighting-01-life-04-v3-sharp-v1.webp",
        "width": 1122
      },
      {
        "src": "lighting-01-life-04-v3-sharp-1600-v1.webp",
        "width": 1600
      },
      {
        "src": "lighting-01-life-04-v3-hq2x-v1.webp",
        "width": 2244
      }
    ]
  },
  "lighting-07-life-04-v3.webp": {
    "src": "lighting-07-life-04-v3-hq2x-v1.webp",
    "displaySrc": "lighting-07-life-04-v3-sharp-v1.webp",
    "width": 2244,
    "height": 2804,
    "originalWidth": 1122,
    "originalHeight": 1402,
    "sources": [
      {
        "src": "lighting-07-life-04-v3-sharp-640-v1.webp",
        "width": 640
      },
      {
        "src": "lighting-07-life-04-v3-sharp-v1.webp",
        "width": 1122
      },
      {
        "src": "lighting-07-life-04-v3-sharp-1600-v1.webp",
        "width": 1600
      },
      {
        "src": "lighting-07-life-04-v3-hq2x-v1.webp",
        "width": 2244
      }
    ]
  },
  "lighting-08-life-04-v3.webp": {
    "src": "lighting-08-life-04-v3-hq2x-v1.webp",
    "displaySrc": "lighting-08-life-04-v3-sharp-v1.webp",
    "width": 2244,
    "height": 2804,
    "originalWidth": 1122,
    "originalHeight": 1402,
    "sources": [
      {
        "src": "lighting-08-life-04-v3-sharp-640-v1.webp",
        "width": 640
      },
      {
        "src": "lighting-08-life-04-v3-sharp-v1.webp",
        "width": 1122
      },
      {
        "src": "lighting-08-life-04-v3-sharp-1600-v1.webp",
        "width": 1600
      },
      {
        "src": "lighting-08-life-04-v3-hq2x-v1.webp",
        "width": 2244
      }
    ]
  },
  "lighting-06-life-04-v3.webp": {
    "src": "lighting-06-life-04-v3-hq2x-v1.webp",
    "displaySrc": "lighting-06-life-04-v3-sharp-v1.webp",
    "width": 2244,
    "height": 2804,
    "originalWidth": 1122,
    "originalHeight": 1402,
    "sources": [
      {
        "src": "lighting-06-life-04-v3-sharp-640-v1.webp",
        "width": 640
      },
      {
        "src": "lighting-06-life-04-v3-sharp-v1.webp",
        "width": 1122
      },
      {
        "src": "lighting-06-life-04-v3-sharp-1600-v1.webp",
        "width": 1600
      },
      {
        "src": "lighting-06-life-04-v3-hq2x-v1.webp",
        "width": 2244
      }
    ]
  },
  "lighting-09-life-04-v3.webp": {
    "src": "lighting-09-life-04-v3-hq2x-v1.webp",
    "displaySrc": "lighting-09-life-04-v3-sharp-v1.webp",
    "width": 2244,
    "height": 2804,
    "originalWidth": 1122,
    "originalHeight": 1402,
    "sources": [
      {
        "src": "lighting-09-life-04-v3-sharp-640-v1.webp",
        "width": 640
      },
      {
        "src": "lighting-09-life-04-v3-sharp-v1.webp",
        "width": 1122
      },
      {
        "src": "lighting-09-life-04-v3-sharp-1600-v1.webp",
        "width": 1600
      },
      {
        "src": "lighting-09-life-04-v3-hq2x-v1.webp",
        "width": 2244
      }
    ]
  },
  "lighting-10-life-04-v3.webp": {
    "src": "lighting-10-life-04-v3-hq2x-v1.webp",
    "displaySrc": "lighting-10-life-04-v3-sharp-v1.webp",
    "width": 2244,
    "height": 2804,
    "originalWidth": 1122,
    "originalHeight": 1402,
    "sources": [
      {
        "src": "lighting-10-life-04-v3-sharp-640-v1.webp",
        "width": 640
      },
      {
        "src": "lighting-10-life-04-v3-sharp-v1.webp",
        "width": 1122
      },
      {
        "src": "lighting-10-life-04-v3-sharp-1600-v1.webp",
        "width": 1600
      },
      {
        "src": "lighting-10-life-04-v3-hq2x-v1.webp",
        "width": 2244
      }
    ]
  },
  "lighting-11-life-04-v3.webp": {
    "src": "lighting-11-life-04-v3-hq2x-v1.webp",
    "displaySrc": "lighting-11-life-04-v3-sharp-v1.webp",
    "width": 2244,
    "height": 2804,
    "originalWidth": 1122,
    "originalHeight": 1402,
    "sources": [
      {
        "src": "lighting-11-life-04-v3-sharp-640-v1.webp",
        "width": 640
      },
      {
        "src": "lighting-11-life-04-v3-sharp-v1.webp",
        "width": 1122
      },
      {
        "src": "lighting-11-life-04-v3-sharp-1600-v1.webp",
        "width": 1600
      },
      {
        "src": "lighting-11-life-04-v3-hq2x-v1.webp",
        "width": 2244
      }
    ]
  },
  "lighting-13-life-04-v3.webp": {
    "src": "lighting-13-life-04-v3-hq2x-v1.webp",
    "displaySrc": "lighting-13-life-04-v3-sharp-v1.webp",
    "width": 2244,
    "height": 2804,
    "originalWidth": 1122,
    "originalHeight": 1402,
    "sources": [
      {
        "src": "lighting-13-life-04-v3-sharp-640-v1.webp",
        "width": 640
      },
      {
        "src": "lighting-13-life-04-v3-sharp-v1.webp",
        "width": 1122
      },
      {
        "src": "lighting-13-life-04-v3-sharp-1600-v1.webp",
        "width": 1600
      },
      {
        "src": "lighting-13-life-04-v3-hq2x-v1.webp",
        "width": 2244
      }
    ]
  },
  "lighting-12-life-04-v3.webp": {
    "src": "lighting-12-life-04-v3-hq2x-v1.webp",
    "displaySrc": "lighting-12-life-04-v3-sharp-v1.webp",
    "width": 2244,
    "height": 2804,
    "originalWidth": 1122,
    "originalHeight": 1402,
    "sources": [
      {
        "src": "lighting-12-life-04-v3-sharp-640-v1.webp",
        "width": 640
      },
      {
        "src": "lighting-12-life-04-v3-sharp-v1.webp",
        "width": 1122
      },
      {
        "src": "lighting-12-life-04-v3-sharp-1600-v1.webp",
        "width": 1600
      },
      {
        "src": "lighting-12-life-04-v3-hq2x-v1.webp",
        "width": 2244
      }
    ]
  },
  "lighting-16-life-04-v3.webp": {
    "src": "lighting-16-life-04-v3-hq2x-v1.webp",
    "displaySrc": "lighting-16-life-04-v3-sharp-v1.webp",
    "width": 2244,
    "height": 2804,
    "originalWidth": 1122,
    "originalHeight": 1402,
    "sources": [
      {
        "src": "lighting-16-life-04-v3-sharp-640-v1.webp",
        "width": 640
      },
      {
        "src": "lighting-16-life-04-v3-sharp-v1.webp",
        "width": 1122
      },
      {
        "src": "lighting-16-life-04-v3-sharp-1600-v1.webp",
        "width": 1600
      },
      {
        "src": "lighting-16-life-04-v3-hq2x-v1.webp",
        "width": 2244
      }
    ]
  },
  "lighting-17-life-04-v3.webp": {
    "src": "lighting-17-life-04-v3-hq2x-v1.webp",
    "displaySrc": "lighting-17-life-04-v3-sharp-v1.webp",
    "width": 2244,
    "height": 2804,
    "originalWidth": 1122,
    "originalHeight": 1402,
    "sources": [
      {
        "src": "lighting-17-life-04-v3-sharp-640-v1.webp",
        "width": 640
      },
      {
        "src": "lighting-17-life-04-v3-sharp-v1.webp",
        "width": 1122
      },
      {
        "src": "lighting-17-life-04-v3-sharp-1600-v1.webp",
        "width": 1600
      },
      {
        "src": "lighting-17-life-04-v3-hq2x-v1.webp",
        "width": 2244
      }
    ]
  },
  "lighting-14-life-04-v3.webp": {
    "src": "lighting-14-life-04-v3-hq2x-v1.webp",
    "displaySrc": "lighting-14-life-04-v3-sharp-v1.webp",
    "width": 2244,
    "height": 2804,
    "originalWidth": 1122,
    "originalHeight": 1402,
    "sources": [
      {
        "src": "lighting-14-life-04-v3-sharp-640-v1.webp",
        "width": 640
      },
      {
        "src": "lighting-14-life-04-v3-sharp-v1.webp",
        "width": 1122
      },
      {
        "src": "lighting-14-life-04-v3-sharp-1600-v1.webp",
        "width": 1600
      },
      {
        "src": "lighting-14-life-04-v3-hq2x-v1.webp",
        "width": 2244
      }
    ]
  },
  "lighting-15-life-04-v3.webp": {
    "src": "lighting-15-life-04-v3-hq2x-v1.webp",
    "displaySrc": "lighting-15-life-04-v3-sharp-v1.webp",
    "width": 2244,
    "height": 2804,
    "originalWidth": 1122,
    "originalHeight": 1402,
    "sources": [
      {
        "src": "lighting-15-life-04-v3-sharp-640-v1.webp",
        "width": 640
      },
      {
        "src": "lighting-15-life-04-v3-sharp-v1.webp",
        "width": 1122
      },
      {
        "src": "lighting-15-life-04-v3-sharp-1600-v1.webp",
        "width": 1600
      },
      {
        "src": "lighting-15-life-04-v3-hq2x-v1.webp",
        "width": 2244
      }
    ]
  },
  "lighting-18-life-04-v3.webp": {
    "src": "lighting-18-life-04-v3-hq2x-v1.webp",
    "displaySrc": "lighting-18-life-04-v3-sharp-v1.webp",
    "width": 2244,
    "height": 2804,
    "originalWidth": 1122,
    "originalHeight": 1402,
    "sources": [
      {
        "src": "lighting-18-life-04-v3-sharp-640-v1.webp",
        "width": 640
      },
      {
        "src": "lighting-18-life-04-v3-sharp-v1.webp",
        "width": 1122
      },
      {
        "src": "lighting-18-life-04-v3-sharp-1600-v1.webp",
        "width": 1600
      },
      {
        "src": "lighting-18-life-04-v3-hq2x-v1.webp",
        "width": 2244
      }
    ]
  },
  "lighting-01-life-05-v3.webp": {
    "src": "lighting-01-life-05-v3-hq2x-v1.webp",
    "displaySrc": "lighting-01-life-05-v3-sharp-v1.webp",
    "width": 2244,
    "height": 2804,
    "originalWidth": 1122,
    "originalHeight": 1402,
    "sources": [
      {
        "src": "lighting-01-life-05-v3-sharp-640-v1.webp",
        "width": 640
      },
      {
        "src": "lighting-01-life-05-v3-sharp-v1.webp",
        "width": 1122
      },
      {
        "src": "lighting-01-life-05-v3-sharp-1600-v1.webp",
        "width": 1600
      },
      {
        "src": "lighting-01-life-05-v3-hq2x-v1.webp",
        "width": 2244
      }
    ]
  },
  "lighting-02-life-05-v3.webp": {
    "src": "lighting-02-life-05-v3-hq2x-v1.webp",
    "displaySrc": "lighting-02-life-05-v3-sharp-v1.webp",
    "width": 2244,
    "height": 2804,
    "originalWidth": 1122,
    "originalHeight": 1402,
    "sources": [
      {
        "src": "lighting-02-life-05-v3-sharp-640-v1.webp",
        "width": 640
      },
      {
        "src": "lighting-02-life-05-v3-sharp-v1.webp",
        "width": 1122
      },
      {
        "src": "lighting-02-life-05-v3-sharp-1600-v1.webp",
        "width": 1600
      },
      {
        "src": "lighting-02-life-05-v3-hq2x-v1.webp",
        "width": 2244
      }
    ]
  },
  "lighting-19-life-04-v3.webp": {
    "src": "lighting-19-life-04-v3-hq2x-v1.webp",
    "displaySrc": "lighting-19-life-04-v3-sharp-v1.webp",
    "width": 2244,
    "height": 2804,
    "originalWidth": 1122,
    "originalHeight": 1402,
    "sources": [
      {
        "src": "lighting-19-life-04-v3-sharp-640-v1.webp",
        "width": 640
      },
      {
        "src": "lighting-19-life-04-v3-sharp-v1.webp",
        "width": 1122
      },
      {
        "src": "lighting-19-life-04-v3-sharp-1600-v1.webp",
        "width": 1600
      },
      {
        "src": "lighting-19-life-04-v3-hq2x-v1.webp",
        "width": 2244
      }
    ]
  },
  "lighting-20-life-04-v3.webp": {
    "src": "lighting-20-life-04-v3-hq2x-v1.webp",
    "displaySrc": "lighting-20-life-04-v3-sharp-v1.webp",
    "width": 2244,
    "height": 2804,
    "originalWidth": 1122,
    "originalHeight": 1402,
    "sources": [
      {
        "src": "lighting-20-life-04-v3-sharp-640-v1.webp",
        "width": 640
      },
      {
        "src": "lighting-20-life-04-v3-sharp-v1.webp",
        "width": 1122
      },
      {
        "src": "lighting-20-life-04-v3-sharp-1600-v1.webp",
        "width": 1600
      },
      {
        "src": "lighting-20-life-04-v3-hq2x-v1.webp",
        "width": 2244
      }
    ]
  },
  "lighting-03-life-05-v3.webp": {
    "src": "lighting-03-life-05-v3-hq2x-v1.webp",
    "displaySrc": "lighting-03-life-05-v3-sharp-v1.webp",
    "width": 2244,
    "height": 2804,
    "originalWidth": 1122,
    "originalHeight": 1402,
    "sources": [
      {
        "src": "lighting-03-life-05-v3-sharp-640-v1.webp",
        "width": 640
      },
      {
        "src": "lighting-03-life-05-v3-sharp-v1.webp",
        "width": 1122
      },
      {
        "src": "lighting-03-life-05-v3-sharp-1600-v1.webp",
        "width": 1600
      },
      {
        "src": "lighting-03-life-05-v3-hq2x-v1.webp",
        "width": 2244
      }
    ]
  },
  "lighting-05-life-05-v3.webp": {
    "src": "lighting-05-life-05-v3-hq2x-v1.webp",
    "displaySrc": "lighting-05-life-05-v3-sharp-v1.webp",
    "width": 2244,
    "height": 2804,
    "originalWidth": 1122,
    "originalHeight": 1402,
    "sources": [
      {
        "src": "lighting-05-life-05-v3-sharp-640-v1.webp",
        "width": 640
      },
      {
        "src": "lighting-05-life-05-v3-sharp-v1.webp",
        "width": 1122
      },
      {
        "src": "lighting-05-life-05-v3-sharp-1600-v1.webp",
        "width": 1600
      },
      {
        "src": "lighting-05-life-05-v3-hq2x-v1.webp",
        "width": 2244
      }
    ]
  },
  "lighting-06-life-05-v3.webp": {
    "src": "lighting-06-life-05-v3-hq2x-v1.webp",
    "displaySrc": "lighting-06-life-05-v3-sharp-v1.webp",
    "width": 2244,
    "height": 2804,
    "originalWidth": 1122,
    "originalHeight": 1402,
    "sources": [
      {
        "src": "lighting-06-life-05-v3-sharp-640-v1.webp",
        "width": 640
      },
      {
        "src": "lighting-06-life-05-v3-sharp-v1.webp",
        "width": 1122
      },
      {
        "src": "lighting-06-life-05-v3-sharp-1600-v1.webp",
        "width": 1600
      },
      {
        "src": "lighting-06-life-05-v3-hq2x-v1.webp",
        "width": 2244
      }
    ]
  },
  "lighting-07-life-05-v3.webp": {
    "src": "lighting-07-life-05-v3-hq2x-v1.webp",
    "displaySrc": "lighting-07-life-05-v3-sharp-v1.webp",
    "width": 2244,
    "height": 2804,
    "originalWidth": 1122,
    "originalHeight": 1402,
    "sources": [
      {
        "src": "lighting-07-life-05-v3-sharp-640-v1.webp",
        "width": 640
      },
      {
        "src": "lighting-07-life-05-v3-sharp-v1.webp",
        "width": 1122
      },
      {
        "src": "lighting-07-life-05-v3-sharp-1600-v1.webp",
        "width": 1600
      },
      {
        "src": "lighting-07-life-05-v3-hq2x-v1.webp",
        "width": 2244
      }
    ]
  },
  "lighting-08-life-05-v3.webp": {
    "src": "lighting-08-life-05-v3-hq2x-v1.webp",
    "displaySrc": "lighting-08-life-05-v3-sharp-v1.webp",
    "width": 2244,
    "height": 2804,
    "originalWidth": 1122,
    "originalHeight": 1402,
    "sources": [
      {
        "src": "lighting-08-life-05-v3-sharp-640-v1.webp",
        "width": 640
      },
      {
        "src": "lighting-08-life-05-v3-sharp-v1.webp",
        "width": 1122
      },
      {
        "src": "lighting-08-life-05-v3-sharp-1600-v1.webp",
        "width": 1600
      },
      {
        "src": "lighting-08-life-05-v3-hq2x-v1.webp",
        "width": 2244
      }
    ]
  },
  "lighting-09-life-05-v3.webp": {
    "src": "lighting-09-life-05-v3-hq2x-v1.webp",
    "displaySrc": "lighting-09-life-05-v3-sharp-v1.webp",
    "width": 2244,
    "height": 2804,
    "originalWidth": 1122,
    "originalHeight": 1402,
    "sources": [
      {
        "src": "lighting-09-life-05-v3-sharp-640-v1.webp",
        "width": 640
      },
      {
        "src": "lighting-09-life-05-v3-sharp-v1.webp",
        "width": 1122
      },
      {
        "src": "lighting-09-life-05-v3-sharp-1600-v1.webp",
        "width": 1600
      },
      {
        "src": "lighting-09-life-05-v3-hq2x-v1.webp",
        "width": 2244
      }
    ]
  },
  "lighting-10-life-05-v3.webp": {
    "src": "lighting-10-life-05-v3-hq2x-v1.webp",
    "displaySrc": "lighting-10-life-05-v3-sharp-v1.webp",
    "width": 2244,
    "height": 2804,
    "originalWidth": 1122,
    "originalHeight": 1402,
    "sources": [
      {
        "src": "lighting-10-life-05-v3-sharp-640-v1.webp",
        "width": 640
      },
      {
        "src": "lighting-10-life-05-v3-sharp-v1.webp",
        "width": 1122
      },
      {
        "src": "lighting-10-life-05-v3-sharp-1600-v1.webp",
        "width": 1600
      },
      {
        "src": "lighting-10-life-05-v3-hq2x-v1.webp",
        "width": 2244
      }
    ]
  },
  "lighting-11-life-05-v3.webp": {
    "src": "lighting-11-life-05-v3-hq2x-v1.webp",
    "displaySrc": "lighting-11-life-05-v3-sharp-v1.webp",
    "width": 2244,
    "height": 2804,
    "originalWidth": 1122,
    "originalHeight": 1402,
    "sources": [
      {
        "src": "lighting-11-life-05-v3-sharp-640-v1.webp",
        "width": 640
      },
      {
        "src": "lighting-11-life-05-v3-sharp-v1.webp",
        "width": 1122
      },
      {
        "src": "lighting-11-life-05-v3-sharp-1600-v1.webp",
        "width": 1600
      },
      {
        "src": "lighting-11-life-05-v3-hq2x-v1.webp",
        "width": 2244
      }
    ]
  },
  "lighting-13-life-05-v3.webp": {
    "src": "lighting-13-life-05-v3-hq2x-v1.webp",
    "displaySrc": "lighting-13-life-05-v3-sharp-v1.webp",
    "width": 2244,
    "height": 2804,
    "originalWidth": 1122,
    "originalHeight": 1402,
    "sources": [
      {
        "src": "lighting-13-life-05-v3-sharp-640-v1.webp",
        "width": 640
      },
      {
        "src": "lighting-13-life-05-v3-sharp-v1.webp",
        "width": 1122
      },
      {
        "src": "lighting-13-life-05-v3-sharp-1600-v1.webp",
        "width": 1600
      },
      {
        "src": "lighting-13-life-05-v3-hq2x-v1.webp",
        "width": 2244
      }
    ]
  },
  "lighting-14-life-05-v3.webp": {
    "src": "lighting-14-life-05-v3-hq2x-v1.webp",
    "displaySrc": "lighting-14-life-05-v3-sharp-v1.webp",
    "width": 2244,
    "height": 2804,
    "originalWidth": 1122,
    "originalHeight": 1402,
    "sources": [
      {
        "src": "lighting-14-life-05-v3-sharp-640-v1.webp",
        "width": 640
      },
      {
        "src": "lighting-14-life-05-v3-sharp-v1.webp",
        "width": 1122
      },
      {
        "src": "lighting-14-life-05-v3-sharp-1600-v1.webp",
        "width": 1600
      },
      {
        "src": "lighting-14-life-05-v3-hq2x-v1.webp",
        "width": 2244
      }
    ]
  },
  "lighting-12-life-05-v3.webp": {
    "src": "lighting-12-life-05-v3-hq2x-v1.webp",
    "displaySrc": "lighting-12-life-05-v3-sharp-v1.webp",
    "width": 2244,
    "height": 2804,
    "originalWidth": 1122,
    "originalHeight": 1402,
    "sources": [
      {
        "src": "lighting-12-life-05-v3-sharp-640-v1.webp",
        "width": 640
      },
      {
        "src": "lighting-12-life-05-v3-sharp-v1.webp",
        "width": 1122
      },
      {
        "src": "lighting-12-life-05-v3-sharp-1600-v1.webp",
        "width": 1600
      },
      {
        "src": "lighting-12-life-05-v3-hq2x-v1.webp",
        "width": 2244
      }
    ]
  },
  "lighting-16-life-05-v3.webp": {
    "src": "lighting-16-life-05-v3-hq2x-v1.webp",
    "displaySrc": "lighting-16-life-05-v3-sharp-v1.webp",
    "width": 2244,
    "height": 2804,
    "originalWidth": 1122,
    "originalHeight": 1402,
    "sources": [
      {
        "src": "lighting-16-life-05-v3-sharp-640-v1.webp",
        "width": 640
      },
      {
        "src": "lighting-16-life-05-v3-sharp-v1.webp",
        "width": 1122
      },
      {
        "src": "lighting-16-life-05-v3-sharp-1600-v1.webp",
        "width": 1600
      },
      {
        "src": "lighting-16-life-05-v3-hq2x-v1.webp",
        "width": 2244
      }
    ]
  },
  "lighting-18-life-05-v3.webp": {
    "src": "lighting-18-life-05-v3-hq2x-v1.webp",
    "displaySrc": "lighting-18-life-05-v3-sharp-v1.webp",
    "width": 2244,
    "height": 2804,
    "originalWidth": 1122,
    "originalHeight": 1402,
    "sources": [
      {
        "src": "lighting-18-life-05-v3-sharp-640-v1.webp",
        "width": 640
      },
      {
        "src": "lighting-18-life-05-v3-sharp-v1.webp",
        "width": 1122
      },
      {
        "src": "lighting-18-life-05-v3-sharp-1600-v1.webp",
        "width": 1600
      },
      {
        "src": "lighting-18-life-05-v3-hq2x-v1.webp",
        "width": 2244
      }
    ]
  },
  "lighting-19-life-05-v3.webp": {
    "src": "lighting-19-life-05-v3-hq2x-v1.webp",
    "displaySrc": "lighting-19-life-05-v3-sharp-v1.webp",
    "width": 2244,
    "height": 2804,
    "originalWidth": 1122,
    "originalHeight": 1402,
    "sources": [
      {
        "src": "lighting-19-life-05-v3-sharp-640-v1.webp",
        "width": 640
      },
      {
        "src": "lighting-19-life-05-v3-sharp-v1.webp",
        "width": 1122
      },
      {
        "src": "lighting-19-life-05-v3-sharp-1600-v1.webp",
        "width": 1600
      },
      {
        "src": "lighting-19-life-05-v3-hq2x-v1.webp",
        "width": 2244
      }
    ]
  },
  "lighting-17-life-05-v3.webp": {
    "src": "lighting-17-life-05-v3-hq2x-v1.webp",
    "displaySrc": "lighting-17-life-05-v3-sharp-v1.webp",
    "width": 2244,
    "height": 2804,
    "originalWidth": 1122,
    "originalHeight": 1402,
    "sources": [
      {
        "src": "lighting-17-life-05-v3-sharp-640-v1.webp",
        "width": 640
      },
      {
        "src": "lighting-17-life-05-v3-sharp-v1.webp",
        "width": 1122
      },
      {
        "src": "lighting-17-life-05-v3-sharp-1600-v1.webp",
        "width": 1600
      },
      {
        "src": "lighting-17-life-05-v3-hq2x-v1.webp",
        "width": 2244
      }
    ]
  },
  "lighting-15-life-05-v3.webp": {
    "src": "lighting-15-life-05-v3-hq2x-v1.webp",
    "displaySrc": "lighting-15-life-05-v3-sharp-v1.webp",
    "width": 2244,
    "height": 2804,
    "originalWidth": 1122,
    "originalHeight": 1402,
    "sources": [
      {
        "src": "lighting-15-life-05-v3-sharp-640-v1.webp",
        "width": 640
      },
      {
        "src": "lighting-15-life-05-v3-sharp-v1.webp",
        "width": 1122
      },
      {
        "src": "lighting-15-life-05-v3-sharp-1600-v1.webp",
        "width": 1600
      },
      {
        "src": "lighting-15-life-05-v3-hq2x-v1.webp",
        "width": 2244
      }
    ]
  }
};
